/*
 * LyteWork Plaque Customizer - Enhanced Edition
 * Live preview with AI suggestions
 */


class PlaqueCustomizer {
    constructor() {
        console.log('🔧 PlaqueCustomizer: Constructor started');
        this.config = {
            logoUrl: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/Lw_logo_04_Artboard_2_Copy_3.png?v=1732912722',
            
            // Engraving color options
            engravingColors: [
                { id: 'black-silver', name: 'Black/Silver', engravingColor: '#C4C4C4', bgColor: 'Black', cost: 0, 
                  thumb: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_GInv_Black-Silver.png?v=1736619472' },
                { id: 'red-silver', name: 'Red/Silver', engravingColor: '#C4C4C4', bgColor: 'Red', cost: 0,
                  thumb: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_VN1J_Red-Silver.png?v=1736619486' },
                { id: 'blue-silver', name: 'Blue/Silver', engravingColor: '#C4C4C4', bgColor: 'Blue', cost: 0,
                  thumb: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_GhYz_Blue-Silver.png?v=1736619495' },
                { id: 'green-silver', name: 'Green/Silver', engravingColor: '#C4C4C4', bgColor: 'Green', cost: 0,
                  thumb: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_CXht_Green-Silver.png?v=1736619505' },
                { id: 'black-gold', name: 'Black/Gold', engravingColor: '#B8A35F', bgColor: 'Black', cost: 0.04,
                  thumb: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_USN2_Black-Gold.png?v=1736619513' },
                { id: 'red-gold', name: 'Red/Gold', engravingColor: '#B8A35F', bgColor: 'Red', cost: 0.04,
                  thumb: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_ZG4L_Red-Gold.png?v=1736619522' },
                { id: 'blue-gold', name: 'Blue/Gold', engravingColor: '#B8A35F', bgColor: 'Blue', cost: 0.04,
                  thumb: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_rxOr_Blue-Gold.png?v=1736619531' },
                { id: 'green-gold', name: 'Green/Gold', engravingColor: '#B8A35F', bgColor: 'Green', cost: 0.04,
                  thumb: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_lhKa_Green-Gold.png?v=1736619540' }
            ],
            
            // Background plate textures
            backgroundPlates: {
                Black: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_0sYk_Black_20Metal.png?v=1736619548',
                Red: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_pQJS_Red_20Metal.png?v=1736619603',
                Blue: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_CC7H_Blue_20Metal.png?v=1736619615',
                Green: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_6Fms_Green_20Metal.png?v=1736619624'
            },
            
            // Optional base plates
            basePlates: {
                Gold: { url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_7osf_Gold_20Metal.png?v=1736619642', cost: 0.08 },
                Silver: { url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_EbR7_Silver_20Metal.png?v=1736619633', cost: 0.08 }
            },


            // Headline Templates
            headlineTemplates: {
    'Corporate Awards': [
        { name: 'Employee of the Year', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/EMPLOYEE_OF_THE_YEAR.png?v=1751592307' },
        { name: 'Employee of the Year', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/EMPLOYEE_OF_THE_MONTH.png?v=1751592306'},
        { name: 'Leadership Award 1', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/LEADERSHIP_1.png?v=1751592307' },
        { name: 'Leadership Award 2', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/LEADERSHIP_2.png?v=1751592306' },
        { name: 'World Class Leadership', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/WORLD_CLASS_LEADERSHIP.png?v=1751592306' },
        { name: 'Years of Service 1', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/YEARS_OF_SERVICE_1.png?v=1751592306' },
        { name: 'Years of Service 2', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/YEARS_OF_SERVICE_2.png?v=1751592306' },
        { name: 'Years of Service 3', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/YEARS_OF_SERVICE_3.png?v=1751592305' },
        { name: 'Retirement', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/RETIREMENT.png?v=1751592306' }
    ],
    'School Awards': [
        { name: 'Attendance', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/ATTENDANCE.png?v=1751592306' },
        { name: 'Citizenship', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/CITIZENSHIP_AWARD.png?v=1751592306' },
        { name: 'Academic Excellence', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/ACADEMIC_EXCELLENCE.png?v=1751592306' }
    ],
    'Placement': [
        { name: '1st Place', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/1ST_PLACE_2.png?v=1753494295' },
        { name: '2nd Place', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/2ND_PLACE_2.png?v=1753494316' },
        { name: '3rd Place', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/3RD_PLACE_2.png?v=1753494329' },
        { name: '4th Place', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/4TH_PLACE_2.png?v=1753494337' },
        { name: '5th Place', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/5TH_PLACE_2.png?v=1753494346' },
        { name: '6th Place', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/6TH_PLACE_2.png?v=1753494353' },
        { name: 'Honorable Mention', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/HONORABLE_MENTION.png?v=1751592306' },
        { name: 'Participant', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/PARTICIPANT.png?v=1751592306' }
    ],
    'Recognition': [
        { name: 'All Star Award', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/ALL_STAR_AWARD.png?v=1751592306' },
        { name: 'Super Star Award', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/SUPER_STAR_AWARD.png?v=1751592306' },
        { name: 'Rising Star Award', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/RISING_STAR_AWARD.png?v=1751592306' },
        { name: 'Award of Excellence', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/AWARD_OF_EXCELLENCE.png?v=1751592306' },
        { name: 'Special Recognition', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/SPECIAL_RECOGNITION.png?v=1751592306' },
        { name: 'In Appreciation', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/In_Appreciation.png?v=1751592306' },
        { name: 'With Heartfelt Appreciation', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/WITH_HEARTFELT_APPRECIATION.png?v=1751592306' }
    ],
    'Coach Awards': [
        { name: 'Baseball Coach', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COACH-BASEBALL.png?v=1751592306' },
        { name: 'Basketball Coach', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COACH-BASKETBALL.png?v=1751592306' },
        { name: 'Bowling Coach', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COACH-BOWLING.png?v=1751592306' },
        { name: 'Hockey Coach', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COACH-HOCKEY.png?v=1751592306' },
        { name: 'Football Coach', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COACH-FOOTBALL.png?v=1751592306' },
        { name: 'Volleyball Coach', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COACH-VOLLEYBALL.png?v=1751592306' },
        { name: 'Soccer Coach', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COACH-SOCCER.png?v=1751592306' },
        { name: 'Tennis Coach', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COACH-TENNIS.png?v=1751592306' }
    ]
},
            
            // Font options
            fonts: [
                { name: 'Arial', value: 'Arial, sans-serif' },
                { name: 'Times New Roman', value: "'Times New Roman', serif" },
                { name: 'Georgia', value: 'Georgia, serif' },
                { name: 'Copperplate', value: "'Copperplate', fantasy", url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COPRGTB.TTF?v=1751605768' },
                { name: 'Monotype Corsiva', value: "'Monotype Corsiva', cursive", url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/MTCORSVA.TTF?v=1751605992' },
                { name: 'Engravers', value: "'Engravers MT', serif", url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/ENGR.TTF?v=1751606144' }
            ],
            
            // Pre-populated text options
            textOptions: {
                presentation: ["Presented To:", "In Recognition Of:", "Awarded To:", "In Honor Of:"],
                message: [
                    "In Recognition of Your Outstanding Service",
                    "For Your Exceptional Dedication and Commitment",
                    "With Heartfelt Appreciation for Your Contributions"
                ]
            },
            
            fees: {
                logoSetup: 15.00
            },
            
            // Plaque type configurations
            // Detected via product tags
            plaqueTypes: {
                standard: {
                    hasPlate: true,
                    colorOptions: 'all'
                },
                acrylic: {
                    hasPlate: false,
                    colorOptions: 'acrylic'
                },
                wood: {
                    hasPlate: false,
                    colorOptions: 'wood'
                },
                woodWithFill: {
                    hasPlate: false,
                    colorOptions: 'woodWithFill'
                }
            },
            
            // Wood engraving colors (no plate) - darker brown
            woodEngravingColors: [
                { id: 'wood-natural', name: 'Natural Wood', engravingColor: '#3E2723', bgColor: 'Wood', cost: 0, 
                  thumb: null, isWoodColor: true }
            ],
            
            // Wood engraving with fill options (silver/gold available)
            woodWithFillEngravingColors: [
                { id: 'wood-natural', name: 'Natural Wood', engravingColor: '#3E2723', bgColor: 'Wood', cost: 0, 
                  thumb: null, isWoodColor: true },
                { id: 'wood-silver-fill', name: 'Silver Fill', engravingColor: '#C4C4C4', bgColor: 'Wood', cost: 3.99, 
                  thumb: null, isWoodColor: true, isFillOption: true },
                { id: 'wood-gold-fill', name: 'Gold Fill', engravingColor: '#B8A35F', bgColor: 'Wood', cost: 3.99, 
                  thumb: null, isWoodColor: true, isFillOption: true }
            ],
            
            // Acrylic engraving color (no plate, white text)
            acrylicEngravingColors: [
                { id: 'acrylic-white', name: 'White', engravingColor: '#E8E8E8', bgColor: 'Acrylic', cost: 0, 
                  thumb: null, isAcrylicColor: true }
            ]
        };
        
        // Application state
        this.state = {
            currentStep: 0,
            product: {},
            plaqueType: 'standard', // 'standard', 'acrylic', 'wood', 'woodWithFill'
            style: {
                orientation: 'Portrait',
                engravingColor: this.config.engravingColors[0],
                useBasePlate: false,
                useCornerScrews: false
            },
            headline: {
    type: 'None',
    template: null,
    customText: '',
    customFont: "'Copperplate', fantasy",
    customSize: 28,
    uploadedLogo: null,
    logoSize: 70,  // NEW - default 70%
    logoSetupFee: false
},
           textFields: {
                presentation: { content: 'Presented To:', font: "'Times New Roman', serif", size: 16 },
                recipient: { content: 'Recipient Name', font: "'Monotype Corsiva', cursive", size: 32 },
                message: { content: 'In Recognition of Your Outstanding Service', font: "'Times New Roman', serif", size: 14 },
                organization: { content: 'Organization Name', font: "'Copperplate', fantasy", size: 20 },
                date: { content: new Date().getFullYear().toString(), font: "'Times New Roman', serif", size: 14 }
            },
    quantity: 1,
    plaques: [],
    currentPreviewIndex: 0,  // NEW
    copySettings: {          // NEW
        presentation: true,
        message: true,
        organization: true,
        date: true
    }
};
        
        this.modal = null;
        this.init();
    }

    // === Security: HTML escape helper to prevent XSS ===
    escapeHtml(str) {
        if (str == null) return '';
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    }
    
init() {
        console.log('🔧 PlaqueCustomizer: init() called');
        this.loadFonts();
        this.attachTrigger();
        console.log('🔧 PlaqueCustomizer: init() complete - trigger attached');
    }
    
loadFonts() {
        const style = document.createElement('style');
        style.textContent = this.config.fonts
            .filter(f => f.url)
            .map(f => `@font-face { font-family: '${f.name}'; src: url('${f.url}'); }`)
            .join('\n');
        document.head.appendChild(style);
    }
    
attachTrigger() {
    console.log('🔧 PlaqueCustomizer: attachTrigger() called');
    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('.lw-plaque-trigger'); 
        if (trigger) {
            console.log('🔧 PlaqueCustomizer: Trigger clicked!');
            e.preventDefault();
            e.stopPropagation();
            this.open();
        }
    });
}
    
async open() {
    console.log('🔧 PlaqueCustomizer: open() called');
    try {
        console.log('🔧 PlaqueCustomizer: About to fetch product data...');
        await this.fetchProductData();
        console.log('🔧 PlaqueCustomizer: Product data fetched, building modal...');
        this.buildModal();
        console.log('🔧 PlaqueCustomizer: Modal built, attaching events...');
        this.attachEventListeners();
        this.setupVariantChangeListener();
        console.log('🔧 PlaqueCustomizer: Updating preview...');
        this.updatePreview();
        this.updatePrice();
        document.body.classList.add('lw-modal-open');
        console.log('🔧 PlaqueCustomizer: open() complete!');
    } catch (error) {
        console.error('❌ Error opening plaque customizer:', error);
        console.error('❌ Error stack:', error.stack);
        document.body.classList.remove('lw-modal-open');
        alert('Sorry, there was an error loading the customizer. Please refresh the page and try again.');
    }
}
    
close() {
        if (this.modal) {
            this.modal.remove();
            this.modal = null;
            document.body.classList.remove('lw-modal-open');
        }
    }




async fetchProductData() {
    console.log('🔧 fetchProductData: Starting...');
    try {
        // ============================================
        // FIXED: Robust product handle extraction
        // ============================================
        const pathname = window.location.pathname;
        console.log('🔧 fetchProductData: pathname =', pathname);
        let productHandle = null;
        
        // Try multiple URL patterns
        // Pattern 1: /collections/*/products/handle
        // Pattern 2: /products/handle
        const collectionMatch = pathname.match(/\/collections\/[^\/]+\/products\/([a-zA-Z0-9_-]+)/i);
        const directMatch = pathname.match(/\/products\/([a-zA-Z0-9_-]+)/i);
        
        console.log('🔧 fetchProductData: collectionMatch =', collectionMatch);
        console.log('🔧 fetchProductData: directMatch =', directMatch);
        
        if (collectionMatch && collectionMatch[1]) {
            productHandle = collectionMatch[1];
            console.log('🔧 Product handle from collection URL:', productHandle);
        } else if (directMatch && directMatch[1]) {
            productHandle = directMatch[1];
            console.log('🔧 Product handle from direct URL:', productHandle);
        }
        
        // Validate we got a handle
        if (!productHandle || productHandle === 'undefined' || productHandle === 'null') {
            console.error('Could not extract product handle from URL:', pathname);
            throw new Error('Product handle not found in URL');
        }
        
        console.log('Fetching product data for:', productHandle);
        
        const response = await fetch(`/products/${productHandle}.js`);
        
        if (!response.ok) {
            throw new Error(`Failed to fetch product: ${response.status} ${response.statusText}`);
        }
        
        const product = await response.json();
        
        const variantId = new URL(window.location).searchParams.get('variant') || product.variants[0].id;
        const variant = product.variants.find(v => v.id == variantId);
        
        console.log('=== VARIANT INFO ===');
        console.log('Variant Title:', variant.title);
        console.log('Product Tags:', product.tags);
        
        // Parse dimensions with support for fractions
        const dimensions = this.parseDimensions(variant.title);
        
        console.log('Parsed Width:', dimensions.width);
        console.log('Parsed Height:', dimensions.height);
        console.log('Square Inches:', dimensions.width * dimensions.height);
        
        this.state.product = {
            title: product.title,
            handle: productHandle, // Store handle for later use
            variantId: variant.id,
            variantTitle: variant.title,
            basePrice: variant.price / 100,
            width: dimensions.width,
            height: dimensions.height,
            featuredImage: variant.featured_image?.src || product.featured_image,
            tags: product.tags || []
        };
        
        // Detect plaque type from tags
        this.detectPlaqueType(product.tags || [], variant.title, product.title);
        
        console.log('=== PLAQUE TYPE DETECTED ===');
        console.log('Type:', this.state.plaqueType);
        
        console.log('=== BASE PLATE CALCULATION ===');
        const sqInches = this.state.product.width * this.state.product.height;
        const rawCost = 0.08 * sqInches;
        const finalCost = Math.ceil(rawCost) - 0.01;
        console.log(`${sqInches} sq in × $0.08 = $${rawCost.toFixed(2)} → rounds to $${finalCost.toFixed(2)}`);
        
    } catch (error) {
        console.error('Error fetching product:', error);
        // Provide more helpful error info
        console.error('Current URL:', window.location.href);
        console.error('Pathname:', window.location.pathname);
        
        this.state.product = {
            title: 'Custom Plaque',
            basePrice: 50,
            width: 7,
            height: 9,
            featuredImage: '',
            tags: []
        };
        this.state.plaqueType = 'standard';
    }
}

// Detect plaque type from tags and titles
detectPlaqueType(tags, variantTitle, productTitle) {
    try {
        // Ensure tags is an array
        if (!tags) tags = [];
        if (typeof tags === 'string') {
            tags = tags.split(',').map(t => t.trim().toLowerCase());
        }
        if (!Array.isArray(tags)) tags = [];
        
        // Normalize tags to lowercase
        tags = tags.map(t => typeof t === 'string' ? t.toLowerCase() : '');
        
        // Detection is now STRICTLY tag-based — no fuzzy text matching.
        // Apply these specific tags to products in Shopify Admin:
        //   - "acrylic-plaque"             → Acrylic plaque (no plate, engraves directly)
        //   - "natural-wood-plaque"        → Natural wood, no fill options
        //   - "natural-wood-plaque-with-fill" → Natural wood with silver/gold fill options
        //   - (none of the above)          → Standard plaque with metal plate (default)
        //
        // This avoids false positives when a collection name like "Wood Plaques"
        // would accidentally match a fuzzy "wood plaque" substring.

        if (tags.includes('acrylic-plaque')) {
            this.state.plaqueType = 'acrylic';
            this.state.style.engravingColor = this.config.acrylicEngravingColors[0];
            console.log('Detected: Acrylic plaque (via acrylic-plaque tag)');
            return;
        }

        if (tags.includes('natural-wood-plaque-with-fill')) {
            this.state.plaqueType = 'woodWithFill';
            this.state.style.engravingColor = this.config.woodWithFillEngravingColors[0];
            console.log('Detected: Natural wood plaque with fill options');
            return;
        }

        if (tags.includes('natural-wood-plaque')) {
            this.state.plaqueType = 'wood';
            this.state.style.engravingColor = this.config.woodEngravingColors[0];
            console.log('Detected: Natural wood plaque (no plate)');
            return;
        }

        // Default: standard plaque with metal plate
        this.state.plaqueType = 'standard';
        this.state.style.engravingColor = this.config.engravingColors[0];
        console.log('Detected: Standard plaque with metal plate (default)');
        
    } catch (error) {
        console.error('Error detecting plaque type:', error);
        this.state.plaqueType = 'standard';
        this.state.style.engravingColor = this.config.engravingColors[0];
    }
}
parseDimensions(title) {
    console.log('Attempting to parse:', title);
    
    // Helper function to convert fractional inches to decimal
    const parseFraction = (str) => {
        // Remove inch marks and extra spaces
        str = str.replace(/"/g, '').replace(/'/g, '').trim();
        
        console.log('Parsing fraction from:', str);
        
        // Check if it contains a fraction (e.g., "10 1/2" or "1/2")
        const fractionMatch = str.match(/(\d+)?\s*(\d+)\/(\d+)/);
        
        if (fractionMatch) {
            const whole = fractionMatch[1] ? parseInt(fractionMatch[1]) : 0;
            const numerator = parseInt(fractionMatch[2]);
            const denominator = parseInt(fractionMatch[3]);
            const result = whole + (numerator / denominator);
            console.log(`  Fraction: ${whole} + ${numerator}/${denominator} = ${result}`);
            return result;
        }
        
        // Otherwise just parse as decimal
        const result = parseFloat(str) || 0;
        console.log(`  Decimal: ${result}`);
        return result;
    };
    
    // IMPROVED REGEX: Handle quotes at end of dimensions, not as separators
    // Matches: "10 1/2" x 13"", "10.5 x 9", "7 x 9", "5x7", etc.
    // Pattern: [dimension with optional fraction and quotes] [separator] [dimension with optional fraction and quotes]
    const match = title.match(/(\d+(?:\s+\d+\/\d+)?(?:\.\d+)?)\s*["']?\s*[x×X]\s*["']?\s*(\d+(?:\s+\d+\/\d+)?(?:\.\d+)?)\s*["']?/i);
    
    console.log('Regex match result:', match);
    
    if (match) {
        const width = parseFraction(match[1]);
        const height = parseFraction(match[2]);
        
        console.log(`✓ Successfully parsed: ${width} x ${height}`);
        
        return { width, height };
    }
    
    // Fallback to default
    console.warn('❌ Could not parse dimensions from:', title, '- using default 7x9');
    return { width: 7, height: 9 };
}


setupVariantChangeListener() {
    // Listen for variant changes on the page
    document.addEventListener('variant:change', async (e) => {
        console.log('Variant changed, updating plaque data...');
        await this.fetchProductData();
        this.updateBasePlatePriceLabel();
        this.updatePrice();
        this.updatePreview();
    });
    
    // Watch for changes to the variant selector directly
    const variantSelector = document.querySelector('select[name="id"]');
    if (variantSelector) {
        variantSelector.addEventListener('change', async () => {
            console.log('Variant selector changed...');
            await this.fetchProductData();
            this.updateBasePlatePriceLabel();
            this.updatePrice();
            this.updatePreview();
        });
    }
    
    // Variant radio watchers moved to setupRadioListeners()
}


buildModal() {
        this.modal = document.createElement('div');
        this.modal.className = 'lw-plaque-modal';
        this.modal.innerHTML = `
            <div class="lw-plaque-overlay"></div>
            <div class="lw-plaque-container">
                <!-- Header -->
                <header class="lw-plaque-header">
                    <div class="lw-header-left">
                        <img src="${this.config.logoUrl}" alt="Logo" class="lw-header-logo">
                        <div>
                            <h2>${this.state.product.title}</h2>
                            <p>${this.state.product.variantTitle || ''}</p>
                        </div>
                    </div>
                    <button class="lw-plaque-close">&times;</button>
                </header>
                
                <!-- Main Content -->
                <div class="lw-plaque-body">
                    <!-- Left: Live Preview -->
                    <div class="lw-plaque-preview-section">
                      <!--  <h3>Live Preview</h3>  REMOVED ON PURPOSE-->
                        <div class="lw-plaque-preview-container" data-orientation="portrait">
                            <img class="lw-plaque-wood" src="${this.state.product.featuredImage}" alt="Plaque">
                            <div class="lw-plaque-baseplate"></div>
                            <div class="lw-plaque-plate">
                                <div class="lw-plaque-engraving">
                                    <div class="lw-headline-layer"></div>
                                    <div class="lw-text-layer"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Right: Customization Options -->
                    <div class="lw-plaque-options-section">
                        <div class="lw-plaque-tabs">
                            <button class="lw-plaque-tab active" data-tab="layout">Layout</button>
                            <button class="lw-plaque-tab" data-tab="headline">Headline</button>
                            <button class="lw-plaque-tab" data-tab="text">Text</button>
                            <button class="lw-plaque-tab" data-tab="quantity">Quantity</button>
                        </div>
                        
                        <div class="lw-plaque-tab-content">
                            ${this.renderLayoutTab()}
                        </div>
                    </div>
                </div>
                
                <!-- Footer -->
                <footer class="lw-plaque-footer">
                    <div class="lw-footer-quantity">
                        <span>Qty:</span>
                        <div class="lw-quantity-control lw-footer-qty-control">
                            <button class="lw-qty-btn lw-footer-qty-btn" data-action="decrease">−</button>
                            <input type="number" class="lw-qty-input lw-footer-qty-input" value="${this.state.quantity}" min="1" max="100">
                            <button class="lw-qty-btn lw-footer-qty-btn" data-action="increase">+</button>
                        </div>
                    </div>
                    <div class="lw-plaque-price">
                        <div class="lw-price-line-footer per-plaque">
                            <span>Per Plaque:</span>
                            <span class="lw-plaque-price-per-plaque">$0.00</span>
                        </div>
                        <div class="lw-price-line-footer total">
                            <span>Total:</span>
                            <span class="lw-plaque-price-value">$0.00</span>
                        </div>
                    </div>
                    <button class="lw-plaque-btn lw-plaque-btn-primary" id="addToCartBtn">Add to Cart</button>
                </footer>
            </div>
        `;
        document.body.appendChild(this.modal);
    }
    
renderLayoutTab() {
        // Get the appropriate color options based on plaque type
        const colorOptions = this.getColorOptionsForPlaqueType();
        const plaqueType = this.state.plaqueType || 'standard';
        const plaqueTypeConfig = this.config.plaqueTypes[plaqueType];
        const hasPlate = plaqueTypeConfig ? plaqueTypeConfig.hasPlate : true;
        
        return `
            <div class="lw-plaque-tab-pane active" data-pane="layout">
                <h4>Orientation</h4>
                <div class="lw-orientation-grid">
                    <div class="lw-orientation-option ${this.state.style.orientation === 'Portrait' ? 'active' : ''}" data-orientation="Portrait">
                        <div class="lw-orientation-visual portrait"></div>
                        <span>Portrait</span>
                    </div>
                    <div class="lw-orientation-option ${this.state.style.orientation === 'Landscape' ? 'active' : ''}" data-orientation="Landscape">
                        <div class="lw-orientation-visual landscape"></div>
                        <span>Landscape</span>
                    </div>
                </div>
                
                <h4>${plaqueType === 'acrylic' ? 'Text Color' : (plaqueType.includes('wood') ? 'Engraving Style' : 'Engraving Color')}</h4>
                ${plaqueType === 'acrylic' ? `
                    <p class="lw-info-text">Acrylic plaques feature white engraving.</p>
                ` : ''}
                ${plaqueType === 'wood' ? `
                    <p class="lw-info-text">Wood plaques are engraved directly into the wood surface.</p>
                ` : ''}
                ${plaqueType === 'woodWithFill' ? `
                    <p class="lw-info-text">Choose natural wood engraving or add color fill for an extra $3.99.</p>
                ` : ''}
                <div class="lw-color-grid ${colorOptions.length <= 3 ? 'lw-color-grid-few' : ''}">
                    ${colorOptions.map(color => {
                        const sqInches = this.state.product.width * this.state.product.height;
                        let priceText = '';
                        if (color.cost > 0) {
                            // For wood fill options, show flat fee
                            if (color.isFillOption) {
                                priceText = `+$${color.cost.toFixed(2)}`;
                            } else {
                                const rawCost = color.cost * sqInches;
                                const roundedCost = Math.ceil(rawCost) - 0.01;
                                priceText = `+$${roundedCost.toFixed(2)}`;
                            }
                        }
                        
                        return `
                            <div class="lw-color-option ${this.state.style.engravingColor.id === color.id ? 'active' : ''} ${color.isWoodColor ? 'lw-wood-color' : ''} ${color.isAcrylicColor ? 'lw-acrylic-color' : ''}" 
                                 data-color-id="${color.id}" data-color-type="${plaqueType}">
                                ${color.thumb ? `<img src="${color.thumb}" alt="${color.name}">` : `
                                    <div class="lw-color-swatch" style="background-color: ${color.engravingColor};"></div>
                                `}
                                <span>${color.name}</span>
                                ${priceText ? `<span class="lw-color-price">${priceText}</span>` : ''}
                            </div>
                        `;
                    }).join('')}
                </div>
                
                ${hasPlate ? `
                    <h4>Options</h4>
                    <label class="lw-toggle-option">
                        <span class="lw-toggle">
                            <input type="checkbox" id="basePlateToggle" ${this.state.style.useBasePlate ? 'checked' : ''}>
                            <span class="lw-toggle-slider"></span>
                        </span>
                        <span id="basePlatePriceLabel">Add Base Plate (+$${this.calculateBasePlateCost().toFixed(2)})</span>
                    </label>
                    
                    <label class="lw-toggle-option">
                        <span class="lw-toggle">
                            <input type="checkbox" id="cornerScrewsToggle" ${this.state.style.useCornerScrews ? 'checked' : ''}>
                            <span class="lw-toggle-slider"></span>
                        </span>
                        <span>Add Corner Tacks (+$1.99)</span>
                    </label>
                ` : `
                    <div class="lw-no-plate-notice">
                        <p class="lw-info-text">This ${plaqueType === 'acrylic' ? 'acrylic' : 'wood'} plaque is engraved directly — no separate engraving plate needed.</p>
                    </div>
                `}
            </div>
        `;
}

// Get the appropriate color options based on plaque type
getColorOptionsForPlaqueType() {
    const plaqueType = this.state.plaqueType || 'standard';
    switch (plaqueType) {
        case 'acrylic':
            return this.config.acrylicEngravingColors || this.config.engravingColors;
        case 'wood':
            return this.config.woodEngravingColors || this.config.engravingColors;
        case 'woodWithFill':
            return this.config.woodWithFillEngravingColors || this.config.engravingColors;
        default:
            return this.config.engravingColors;
    }
}
    
renderHeadlineTab() {
        return `
            <div class="lw-plaque-tab-pane" data-pane="headline">
                <h4>Headline Type</h4>
                <div class="lw-headline-types">
                    <label class="lw-radio-option ${this.state.headline.type === 'None' ? 'active' : ''}">
                        <input type="radio" name="headlineType" value="None" ${this.state.headline.type === 'None' ? 'checked' : ''}>
                        <span>No Headline</span>
                    </label>
                    <label class="lw-radio-option ${this.state.headline.type === 'Template' ? 'active' : ''}">
                        <input type="radio" name="headlineType" value="Template" ${this.state.headline.type === 'Template' ? 'checked' : ''}>
                        <span>Choose Design</span>
                    </label>
                    <label class="lw-radio-option ${this.state.headline.type === 'Custom' ? 'active' : ''}">
                        <input type="radio" name="headlineType" value="Custom" ${this.state.headline.type === 'Custom' ? 'checked' : ''}>
                        <span>Custom Text</span>
                    </label>
                    <label class="lw-radio-option ${this.state.headline.type === 'Logo' ? 'active' : ''}">
                        <input type="radio" name="headlineType" value="Logo" ${this.state.headline.type === 'Logo' ? 'checked' : ''}>
                        <span>Upload Logo</span>
                    </label>
                </div>
                
                <div id="headlineContent"></div>
            </div>
        `;
    }
    
renderTextTab() {
        return `
            <div class="lw-plaque-tab-pane" data-pane="text">
                <div class="lw-ai-section">
                    <p><strong>Need help with text?</strong></p>
                    <button class="lw-plaque-btn lw-plaque-btn-secondary" id="aiSuggestBtn">
                        ✨ Get AI Suggestion
                    </button>
                </div>
                
                ${this.renderTextField('presentation', 'Presentation')}
                ${this.renderTextField('recipient', 'Recipient Name')}
                ${this.renderTextField('message', 'Message', true)}
                ${this.renderTextField('organization', 'Organization')}
                ${this.renderTextField('date', 'Date')}
            </div>
        `;
    }
    
renderTextField(field, label, isTextarea = false) {
        const fieldData = this.state.textFields[field];
        
        // Per-field maxlength based on physical engraving constraints
        const maxLengths = {
            presentation: 50,
            recipient: 60,
            message: 200,
            organization: 60,
            date: 30
        };
        const maxLen = maxLengths[field] || 80;
        
        return `
            <div class="lw-text-field">
                <div class="lw-field-header">
                    <label>${label}</label>
                    <div class="lw-field-controls">
                        <select class="lw-font-select" data-field="${field}">
                            ${this.config.fonts.map(font => 
                                `<option value="${font.value}" ${fieldData.font === font.value ? 'selected' : ''}>${this.escapeHtml(font.name)}</option>`
                            ).join('')}
                        </select>
                        <div class="lw-size-control">
                            <button class="lw-size-btn" data-field="${field}" data-delta="-1">−</button>
                            <span>${fieldData.size}px</span>
                            <button class="lw-size-btn" data-field="${field}" data-delta="1">+</button>
                        </div>
                    </div>
                </div>
                ${isTextarea ? 
                    `<textarea class="lw-text-input" data-field="${field}" rows="3" maxlength="${maxLen}">${this.escapeHtml(fieldData.content)}</textarea>` :
                    `<input type="text" class="lw-text-input" data-field="${field}" value="${this.escapeHtml(fieldData.content)}" maxlength="${maxLen}">`
                }
            </div>
        `;
    }
    
renderQuantityTab() {
    return `
        <div class="lw-plaque-tab-pane" data-pane="quantity">
            ${this.state.quantity > 1 ? `
                <div class="lw-bulk-section">
                    <h4>Customize Each Plaque</h4>
                    <p class="lw-help-text">Edit each plaque individually or use AI to generate all at once.</p>
                    
                    <div class="lw-bulk-actions">
                        <button class="lw-plaque-btn lw-plaque-btn-secondary" id="aiBulkBtn">
                            ✨ AI Generate All
                        </button>
                        <button class="lw-plaque-btn lw-plaque-btn-secondary" id="downloadCSVBtn">
                            📥 Download CSV
                        </button>
                    </div>
                    
                    <!-- Preview Navigation -->
                    <div class="lw-preview-nav">
                        <button class="lw-preview-nav-btn" id="prevPlaqueBtn" ${this.state.currentPreviewIndex === 0 ? 'disabled' : ''}>
                            ← Previous
                        </button>
                        <span class="lw-preview-indicator">
                            Previewing Plaque <strong id="currentPreviewNum">${this.state.currentPreviewIndex + 1}</strong> of ${this.state.quantity}
                        </span>
                        <button class="lw-preview-nav-btn" id="nextPlaqueBtn" ${this.state.currentPreviewIndex >= this.state.quantity - 1 ? 'disabled' : ''}>
                            Next →
                        </button>
                    </div>
                    
                    <!-- Copy Settings -->
                    <div class="lw-copy-settings">
                        <h5>Copy to All Plaques:</h5>
                        <label class="lw-copy-checkbox">
                            <input type="checkbox" data-copy-field="presentation" ${this.state.copySettings.presentation ? 'checked' : ''}>
                            <span>Presentation</span>
                        </label>
                        <label class="lw-copy-checkbox">
                            <input type="checkbox" data-copy-field="message" ${this.state.copySettings.message ? 'checked' : ''}>
                            <span>Message</span>
                        </label>
                        <label class="lw-copy-checkbox">
                            <input type="checkbox" data-copy-field="organization" ${this.state.copySettings.organization ? 'checked' : ''}>
                            <span>Organization</span>
                        </label>
                        <label class="lw-copy-checkbox">
                            <input type="checkbox" data-copy-field="date" ${this.state.copySettings.date ? 'checked' : ''}>
                            <span>Date</span>
                        </label>
                    </div>
                    
                    <!-- Bulk Table -->
                    <div class="lw-bulk-table-wrapper">
                        <table class="lw-bulk-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Presentation</th>
                                    <th>Recipient Name</th>
                                    <th>Message</th>
                                    <th>Organization</th>
                                    <th>Date</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                ${this.renderBulkTableRows()}
                            </tbody>
                        </table>
                    </div>
                    
                    <button class="lw-plaque-btn lw-plaque-btn-secondary lw-add-row-btn" id="addRowBtn">
                        + Add Another Plaque
                    </button>
                </div>
            ` : ''}
            
            <div class="lw-price-breakdown">
                <div class="lw-price-line">
                    <span>Per Plaque:</span>
                    <span>$${this.calculatePerPlaquePrice().toFixed(2)}</span>
                </div>
                <div class="lw-price-line total">
                    <span>Total:</span>
                    <span>$${this.calculateTotalPrice().toFixed(2)}</span>
                </div>
            </div>
        </div>
    `;
}
   renderBulkTableRows() {
    // Initialize plaques array if needed
    while (this.state.plaques.length < this.state.quantity) {
        this.state.plaques.push({
            presentation: this.state.textFields.presentation.content,
            recipient: '',
            message: this.state.textFields.message.content,
            organization: this.state.textFields.organization.content,
            date: this.state.textFields.date.content
        });
    }
    
    return this.state.plaques.slice(0, this.state.quantity).map((plaque, index) => {
        const isCurrentPreview = index === this.state.currentPreviewIndex;
        return `
            <tr class="${isCurrentPreview ? 'preview-active' : ''}" data-row-index="${index}">
                <td class="row-number">${index + 1}</td>
                <td>
                    <input type="text" 
                           class="lw-table-input" 
                           data-plaque-index="${index}" 
                           data-field="presentation"
                           value="${this.escapeHtml(plaque.presentation)}"
                           maxlength="80"
                           ${this.state.copySettings.presentation && index > 0 ? 'readonly' : ''}>
                </td>
                <td>
                    <input type="text" 
                           class="lw-table-input" 
                           data-plaque-index="${index}" 
                           data-field="recipient"
                           value="${this.escapeHtml(plaque.recipient)}"
                           placeholder="Recipient Name"
                           maxlength="50">
                </td>
                <td>
                    <input type="text" 
                           class="lw-table-input" 
                           data-plaque-index="${index}" 
                           data-field="message"
                           value="${this.escapeHtml(plaque.message)}"
                           maxlength="200"
                           ${this.state.copySettings.message && index > 0 ? 'readonly' : ''}>
                </td>
                <td>
                    <input type="text" 
                           class="lw-table-input" 
                           data-plaque-index="${index}" 
                           data-field="organization"
                           value="${this.escapeHtml(plaque.organization)}"
                           maxlength="60"
                           ${this.state.copySettings.organization && index > 0 ? 'readonly' : ''}>
                </td>
                <td>
                    <input type="text" 
                           class="lw-table-input" 
                           data-plaque-index="${index}" 
                           data-field="date"
                           value="${this.escapeHtml(plaque.date)}"
                           maxlength="30"
                           ${this.state.copySettings.date && index > 0 ? 'readonly' : ''}>
                </td>
                <td>
                    <button class="lw-remove-row-btn" data-row-index="${index}">×</button>
                </td>
            </tr>
        `;
    }).join('');
}


    attachEventListeners() {
        // Close button
        this.modal.querySelector('.lw-plaque-close').addEventListener('click', () => this.close());
        this.modal.querySelector('.lw-plaque-overlay').addEventListener('click', () => {
            // Don't close the customizer if a shared disclaimer is currently open.
            // Otherwise, clicking outside the disclaimer can bubble to this handler
            // and close the customizer underneath, breaking the cart-add flow.
            const sharedOverlay = document.getElementById('lwShared-disclaimer-overlay');
            if (sharedOverlay && !sharedOverlay.hasAttribute('hidden')) {
                return;
            }
            this.close();
        });
        
        // Tab switching
        this.modal.querySelectorAll('.lw-plaque-tab').forEach(tab => {
            tab.addEventListener('click', () => this.switchTab(tab.dataset.tab));
        });
        
        // Layout tab events
        this.attachLayoutEvents();
        
        // Add to cart
        this.modal.querySelector('#addToCartBtn').addEventListener('click', () => this.addToCart());
        
        // Footer quantity buttons (always visible)
        this.modal.querySelectorAll('.lw-footer-qty-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                if (btn.dataset.action === 'increase') {
                    this.updateQuantity(1);
                } else {
                    this.updateQuantity(-1);
                }
            });
        });
        
        // Footer quantity input
        const footerQtyInput = this.modal.querySelector('.lw-footer-qty-input');
        if (footerQtyInput) {
            footerQtyInput.addEventListener('change', (e) => {
                this.updateQuantity(0, parseInt(e.target.value));
            });
            footerQtyInput.addEventListener('input', (e) => {
                const val = parseInt(e.target.value);
                if (val && val > 0) {
                    this.updateQuantity(0, val);
                }
            });
        }
        
        // Watch page quantity break radios and page qty input
        this.setupRadioListeners();
        
        // Sync initial quantity from page
        this.syncQuantity();
    }
    
    setupRadioListeners() {
        // Watch for quantity break radio buttons on the product page
        const radios = document.querySelectorAll('input[name="product-qty-breaks"]');
        radios.forEach(r => {
            r.addEventListener('change', () => {
                const qty = parseInt(r.dataset.qty);
                if (qty) this.updateQuantity(0, qty);
            });
        });
        
        // Also watch the main page quantity input
        const pageQtyInput = document.querySelector('input[name="quantity"]');
        if (pageQtyInput) {
            pageQtyInput.addEventListener('change', () => {
                const qty = parseInt(pageQtyInput.value) || 1;
                this.updateQuantity(0, qty);
            });
            pageQtyInput.addEventListener('input', () => {
                const qty = parseInt(pageQtyInput.value) || 1;
                this.updateQuantity(0, qty);
            });
        }
        
        // Watch for clicks on quantity +/- buttons on the page
        const qtyButtons = document.querySelectorAll('[data-quantity-plus], [data-quantity-minus], .quantity-plus, .quantity-minus, .qty-btn, button[name="plus"], button[name="minus"]');
        qtyButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                setTimeout(() => {
                    const pageQty = document.querySelector('input[name="quantity"]');
                    if (pageQty) {
                        const qty = parseInt(pageQty.value) || 1;
                        this.updateQuantity(0, qty);
                    }
                }, 50);
            });
        });
        
        // Watch for variant option radio buttons (size/color changes)
        const variantRadios = document.querySelectorAll('input[type="radio"][name*="option"], input[type="radio"][data-option]');
        variantRadios.forEach(radio => {
            radio.addEventListener('change', () => {
                setTimeout(async () => {
                    await this.fetchProductData();
                    this.updateBasePlatePriceLabel();
                    this.updatePrice();
                    this.updatePreview();
                }, 100);
            });
        });
    }
    
    syncQuantity() {
        const q = document.querySelector('input[name="quantity"]');
        if (q) this.updateQuantity(0, parseInt(q.value) || 1);
    }
    
    updateQuantity(change, setVal) {
        // Prevent infinite loops from event listeners
        if (this._updatingQuantity) return;
        this._updatingQuantity = true;
        
        let newQty = (setVal !== undefined) ? setVal : this.state.quantity + change;
        this.state.quantity = Math.max(1, newQty);
        this.state.currentPreviewIndex = 0;
        
        // Update footer qty input
        const footerInput = this.modal.querySelector('.lw-footer-qty-input');
        if (footerInput) footerInput.value = this.state.quantity;
        
        // Sync to main page quantity input
        const mainInput = document.querySelector('input[name="quantity"]');
        if (mainInput && parseInt(mainInput.value) !== this.state.quantity) {
            mainInput.value = this.state.quantity;
        }
        
        // Re-render quantity tab if it's active (for bulk editing)
        const activeTab = this.modal.querySelector('.lw-plaque-tab.active');
        if (activeTab && activeTab.dataset.tab === 'quantity') {
            this.switchTab('quantity');
        }
        
        this.updatePrice();
        
        this._updatingQuantity = false;
    }
    
    attachLayoutEvents() {
        // Orientation
        this.modal.querySelectorAll('[data-orientation]').forEach(el => {
            el.addEventListener('click', () => {
                this.state.style.orientation = el.dataset.orientation;
                this.modal.querySelectorAll('[data-orientation]').forEach(e => e.classList.remove('active'));
                el.classList.add('active');
                this.updatePreview();
            });
        });
        
        // Color - now supports different color arrays based on plaque type
        this.modal.querySelectorAll('[data-color-id]').forEach(el => {
            el.addEventListener('click', () => {
                const colorId = el.dataset.colorId;
                const colorOptions = this.getColorOptionsForPlaqueType();
                const selectedColor = colorOptions.find(c => c.id === colorId);
                
                if (selectedColor) {
                    this.state.style.engravingColor = selectedColor;
                    this.modal.querySelectorAll('[data-color-id]').forEach(e => e.classList.remove('active'));
                    el.classList.add('active');
                    this.updatePreview();
                    this.updatePrice();
                    this.updateBasePlatePriceLabel();

                    // Auto-scroll to the Options (only for standard plaques with plate options)
                    if (this.config.plaqueTypes[this.state.plaqueType]?.hasPlate) {
                        setTimeout(() => {
                            const optionsSection = this.modal.querySelector('#basePlateToggle');
                            if (optionsSection) {
                                optionsSection.closest('.lw-toggle-option').scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }
                        }, 100);
                    }
                }
            });
        });
        
        
        // Base plate toggle
const basePlateToggle = this.modal.querySelector('#basePlateToggle');
if (basePlateToggle) {
    basePlateToggle.addEventListener('change', (e) => {
        this.state.style.useBasePlate = e.target.checked;
        this.updatePreview();
        this.updatePrice();
        this.updateBasePlatePriceLabel();
    });
}


// Update base plate price label when needed


        
       // Corner screws toggle
const screwsToggle = this.modal.querySelector('#cornerScrewsToggle');
if (screwsToggle) {
    screwsToggle.addEventListener('change', (e) => {
        this.state.style.useCornerScrews = e.target.checked;
        this.updatePreview();
        this.updatePrice();  // ADD THIS LINE
    });
}
    }
    
    attachTextEvents() {
    // Text inputs - MORE SPECIFIC SELECTORS
    const textInputs = this.modal.querySelectorAll('.lw-text-field .lw-text-input');
    textInputs.forEach(input => {
        // Remove any existing listeners
        const newInput = input.cloneNode(true);
        input.parentNode.replaceChild(newInput, input);
        
        newInput.addEventListener('input', (e) => {
            const field = e.target.dataset.field;
            if (field && this.state.textFields[field]) {
                this.state.textFields[field].content = e.target.value;
                this.updatePreview();
            }
        });
    });
    
    // Font selects
    const fontSelects = this.modal.querySelectorAll('.lw-text-field .lw-font-select');
    fontSelects.forEach(select => {
        const newSelect = select.cloneNode(true);
        select.parentNode.replaceChild(newSelect, select);
        
        newSelect.addEventListener('change', (e) => {
            const field = e.target.dataset.field;
            if (field && this.state.textFields[field]) {
                this.state.textFields[field].font = e.target.value;
                this.updatePreview();
            }
        });
    });
    
    // Size buttons
    const sizeButtons = this.modal.querySelectorAll('.lw-text-field .lw-size-btn');
    sizeButtons.forEach(btn => {
        const newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);
        
        ['click', 'touchstart'].forEach(evt => {
            newBtn.addEventListener(evt, (e) => {
                e.preventDefault();
            const field = newBtn.dataset.field;
            const delta = parseInt(newBtn.dataset.delta);
            if (field && this.state.textFields[field]) {
                this.state.textFields[field].size = Math.max(8, Math.min(48, this.state.textFields[field].size + delta));
                
                const sizeDisplay = newBtn.parentElement.querySelector('span');
                sizeDisplay.textContent = `${this.state.textFields[field].size}px`;
                
                this.updatePreview();
            }
            });
        });
    });
    
    // AI suggestion button
    const aiBtn = this.modal.querySelector('#aiSuggestBtn');
    if (aiBtn) {
        aiBtn.addEventListener('click', () => this.getAISuggestion());
    }
}
    
    attachQuantityEvents() {
    // Only attach bulk events if quantity > 1
    if (this.state.quantity > 1) {
        this.attachBulkEvents();
    }
}


attachBulkEvents() {
    // Table input events
    this.modal.querySelectorAll('.lw-table-input').forEach(input => {
        input.addEventListener('input', (e) => {
            const index = parseInt(e.target.dataset.plaqueIndex);
            const field = e.target.dataset.field;
            this.state.plaques[index][field] = e.target.value;
            
            // If this is row 0 and copy is enabled, update all others
            if (index === 0 && this.state.copySettings[field]) {
                for (let i = 1; i < this.state.quantity; i++) {
                    this.state.plaques[i][field] = e.target.value;
                }
            }
            
            // Update preview if viewing this plaque
            if (index === this.state.currentPreviewIndex) {
                this.updatePreviewForPlaque(index);
            }
        });
        
        // Click on input to preview that plaque
        input.addEventListener('click', (e) => {
            const index = parseInt(e.target.dataset.plaqueIndex);
            this.state.currentPreviewIndex = index;
            this.updatePreviewForPlaque(index);
            this.highlightPreviewRow();
        });
    });
    
    // Preview navigation
    const prevBtn = this.modal.querySelector('#prevPlaqueBtn');
    const nextBtn = this.modal.querySelector('#nextPlaqueBtn');
    
    if (prevBtn) {
        prevBtn.addEventListener('click', () => {
            if (this.state.currentPreviewIndex > 0) {
                this.state.currentPreviewIndex--;
                this.updatePreviewForPlaque(this.state.currentPreviewIndex);
                this.updatePreviewNav();
                this.highlightPreviewRow();
            }
        });
    }
    
    if (nextBtn) {
        nextBtn.addEventListener('click', () => {
            if (this.state.currentPreviewIndex < this.state.quantity - 1) {
                this.state.currentPreviewIndex++;
                this.updatePreviewForPlaque(this.state.currentPreviewIndex);
                this.updatePreviewNav();
                this.highlightPreviewRow();
            }
        });
    }
    
    // Copy settings checkboxes
    this.modal.querySelectorAll('.lw-copy-checkbox input').forEach(cb => {
        cb.addEventListener('change', (e) => {
            const field = e.target.dataset.copyField;
            this.state.copySettings[field] = e.target.checked;
            
            if (e.target.checked) {
                // Copy from first plaque to all others
                const sourceValue = this.state.plaques[0][field];
                for (let i = 1; i < this.state.quantity; i++) {
                    this.state.plaques[i][field] = sourceValue;
                }
            }
            
            // Re-render table
            this.switchTab('quantity');
        });
    });
    
    // Remove row button
    this.modal.querySelectorAll('.lw-remove-row-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            if (this.state.quantity > 1) {
                const index = parseInt(btn.dataset.rowIndex);
                this.state.plaques.splice(index, 1);
                this.state.quantity--;
                const footerInput = this.modal.querySelector('.lw-footer-qty-input');
                if (footerInput) footerInput.value = this.state.quantity;
                if (this.state.currentPreviewIndex >= this.state.quantity) {
                    this.state.currentPreviewIndex = this.state.quantity - 1;
                }
                this.switchTab('quantity');
                this.updatePrice();
            }
        });
    });
    
    // Add row button
    const addRowBtn = this.modal.querySelector('#addRowBtn');
    if (addRowBtn) {
        addRowBtn.addEventListener('click', () => {
            this.state.quantity++;
            const footerInput = this.modal.querySelector('.lw-footer-qty-input');
            if (footerInput) footerInput.value = this.state.quantity;
            this.switchTab('quantity');
            this.updatePrice();
        });
    }
    
    // AI Bulk Generate
    const aiBulkBtn = this.modal.querySelector('#aiBulkBtn');
    if (aiBulkBtn) {
        aiBulkBtn.addEventListener('click', () => this.aiBulkGenerate());
    }
    
    // Download CSV
    const downloadCSVBtn = this.modal.querySelector('#downloadCSVBtn');
    if (downloadCSVBtn) {
        downloadCSVBtn.addEventListener('click', () => this.downloadCSV());
    }
}




updatePreviewForPlaque(index) {
    const plaque = this.state.plaques[index];
    
    // Temporarily update text fields with this plaque's data
    Object.keys(plaque).forEach(field => {
        if (this.state.textFields[field]) {
            this.state.textFields[field].content = plaque[field];
        }
    });
    
    this.updatePreview();
}


updatePreviewNav() {
    const currentNum = this.modal.querySelector('#currentPreviewNum');
    const prevBtn = this.modal.querySelector('#prevPlaqueBtn');
    const nextBtn = this.modal.querySelector('#nextPlaqueBtn');
    
    if (currentNum) currentNum.textContent = this.state.currentPreviewIndex + 1;
    if (prevBtn) prevBtn.disabled = this.state.currentPreviewIndex === 0;
    if (nextBtn) nextBtn.disabled = this.state.currentPreviewIndex >= this.state.quantity - 1;
}


highlightPreviewRow() {
    this.modal.querySelectorAll('.lw-bulk-table tr').forEach(row => {
        row.classList.remove('preview-active');
    });
    
    const activeRow = this.modal.querySelector(`tr[data-row-index="${this.state.currentPreviewIndex}"]`);
    if (activeRow) {
        activeRow.classList.add('preview-active');
        activeRow.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
}
async aiBulkGenerate() {
    const occasion = prompt(`What occasion are these ${this.state.quantity} plaques for?\n\nExamples:\n• "Top 5 sales performers"\n• "Employee recognition for 3 team members"\n• "Retirement awards"\n\nBest with 5 or fewer plaques.`);
    
    if (!occasion || occasion.trim() === '') return;
    
    // Strongly recommend fewer plaques
    if (this.state.quantity > 5) {
        if (!confirm(`⚠️ AI works MUCH better with 5 or fewer plaques.\n\nGenerate for first 5 only?\n(You can add more manually after)`)) {
            return;
        }
    }
    
    const generateCount = Math.min(this.state.quantity, 5);
    
    // Show loading
    const loadingNotice = document.createElement('div');
    loadingNotice.id = 'aiBulkLoadingNotice';
    loadingNotice.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        padding: 20px 25px;
        border-radius: 10px;
        box-shadow: 0 5px 20px rgba(0,0,0,0.3);
        z-index: 10001;
        font-weight: 600;
    `;
    loadingNotice.innerHTML = `
        <div style="display: flex; align-items: center; gap: 15px;">
            <div style="
                border: 3px solid rgba(255,255,255,0.3);
                border-top: 3px solid white;
                border-radius: 50%;
                width: 24px;
                height: 24px;
                animation: spin 1s linear infinite;
            "></div>
            <div>Generating ${generateCount} plaques...</div>
        </div>
    `;
    document.body.appendChild(loadingNotice);
    
    try {
        const response = await fetch('https://plaque-ai-helper.noisy-waterfall-ce1b.workers.dev/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                prompt: `Generate ${generateCount} DIFFERENT award plaque texts for: "${occasion}".


FIELD DEFINITIONS:
- presentation = Opening phrase (e.g., "Presented To:", "Awarded To:")
- recipient = Person's NAME only (e.g., "John Smith")
- message = Achievement description (e.g., "Top Sales Performer")
- organization = Company name
- date = Year (${new Date().getFullYear()})


EXAMPLE OUTPUT:
[
{"presentation":"Presented To:","recipient":"Sarah Johnson","message":"Employee of the Year","organization":"ABC Corp","date":"2025"},
{"presentation":"Awarded To:","recipient":"Mike Chen","message":"Outstanding Leadership","organization":"ABC Corp","date":"2025"},
{"presentation":"In Recognition Of:","recipient":"Lisa Martinez","message":"Exceptional Service","organization":"ABC Corp","date":"2025"}
]


Generate ${generateCount} unique plaques. Return ONLY the JSON array (no markdown, no text, no explanations).`,
                productName: 'Plaques',
                productType: 'Bulk'
            })
        });
        
        if (!response.ok) {
            throw new Error(`Server error ${response.status}`);
        }
        
        const data = await response.json();
        console.log('=== BULK AI RAW RESPONSE ===');
        console.log(data);
        
        let responseText = data.text || data.content || data.response || JSON.stringify(data);
        console.log('=== BULK RESPONSE TEXT ===');
        console.log(responseText);
        console.log('=== TEXT LENGTH ===', responseText.length);
        
        // Parse with multiple fallback methods
        let plaquesData = [];
        try {
            // Remove markdown
            responseText = responseText.replace(/```json\s*/g, '').replace(/```\s*/g, '').trim();
            
            console.log('=== CLEANED TEXT ===');
            console.log(responseText);
            
            // Method 1: Try direct parse
            try {
                const parsed = JSON.parse(responseText);
                if (Array.isArray(parsed)) {
                    plaquesData = parsed;
                    console.log('✓ Direct parse successful');
                } else if (parsed.plaques && Array.isArray(parsed.plaques)) {
                    plaquesData = parsed.plaques;
                    console.log('✓ Parsed .plaques property');
                } else {
                    throw new Error('Not an array');
                }
            } catch (e1) {
                console.log('Direct parse failed:', e1.message);
                
                // Method 2: Try finding array with better regex
                const arrayMatch = responseText.match(/\[[^\]]*?\{[\s\S]*?\}[^\]]*?\]/);
                if (arrayMatch) {
                    console.log('=== FOUND ARRAY MATCH ===');
                    console.log(arrayMatch[0]);
                    const parsed = JSON.parse(arrayMatch[0]);
                    plaquesData = Array.isArray(parsed) ? parsed : [];
                    console.log('✓ Array regex parse successful');
                } else {
                    console.log('No array found in response');
                    throw new Error('No array found');
                }
            }
        } catch (parseError) {
            console.error('=== ALL JSON PARSING FAILED ===');
            console.error(parseError);
            
            // LAST RESORT: Create plaques from any text we can find
            alert(`⚠️ AI returned invalid format. Check browser console (F12) for details.\n\nGenerating default plaques instead.\n\nYou can:\n1. Fill in manually\n2. Try with fewer plaques (3 or less)\n3. Use simpler description`);
            
            // Generate default plaques
            for (let i = 0; i < generateCount; i++) {
                plaquesData.push({
                    presentation: 'Presented To:',
                    recipient: `Recipient ${i + 1}`,
                    message: `Outstanding Achievement`,
                    organization: 'Organization Name',
                    date: new Date().getFullYear().toString()
                });
            }
        }
        
        console.log('=== FINAL PARSED DATA ===');
        console.log(plaquesData);
        
        // Remove loading
        loadingNotice.remove();
        
        if (plaquesData.length === 0) {
            throw new Error('No plaques generated');
        }
        
        // Apply to state
        const generated = Math.min(plaquesData.length, this.state.quantity);
        for (let i = 0; i < generated; i++) {
            this.state.plaques[i] = {
                presentation: plaquesData[i].presentation || 'Presented To:',
                recipient: plaquesData[i].recipient || '',
                message: plaquesData[i].message || 'Outstanding Achievement',
                organization: plaquesData[i].organization || 'Organization Name',
                date: plaquesData[i].date || new Date().getFullYear().toString()
            };
        }
        
        // Fill remaining with defaults
        while (this.state.plaques.length < this.state.quantity) {
            this.state.plaques.push({
                presentation: 'Presented To:',
                recipient: '',
                message: 'In Recognition of Outstanding Service',
                organization: 'Organization Name',
                date: new Date().getFullYear().toString()
            });
        }
        
        // Refresh UI
        this.switchTab('quantity');
        this.state.currentPreviewIndex = 0;
        this.updatePreviewForPlaque(0);
        
        // Show success
        const successNotice = document.createElement('div');
        successNotice.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: #28a745;
            color: white;
            padding: 20px 25px;
            border-radius: 10px;
            box-shadow: 0 5px 20px rgba(0,0,0,0.3);
            z-index: 10001;
            font-weight: 600;
        `;
        successNotice.innerHTML = `
            <div style="display: flex; align-items: center; gap: 10px;">
                <span style="font-size: 24px;">✓</span>
                <div>
                    <div style="font-weight: 700;">Generated ${generated} Plaques!</div>
                    <div style="font-size: 14px; margin-top: 5px; opacity: 0.9;">Review and edit as needed.</div>
                </div>
            </div>
        `;
        document.body.appendChild(successNotice);
        
        setTimeout(() => {
            successNotice.style.opacity = '0';
            successNotice.style.transition = 'opacity 0.3s ease';
            setTimeout(() => successNotice.remove(), 300);
        }, 5000);
        
    } catch (error) {
        console.error('=== BULK AI FATAL ERROR ===');
        console.error(error);
        
        const notice = document.getElementById('aiBulkLoadingNotice');
        if (notice) notice.remove();
        
        alert(`Bulk AI failed: ${error.message}\n\nPlease:\n1. Open browser console (F12) to see details\n2. Try 3 plaques or fewer\n3. Use simple description like "Top 3 sales"\n4. Fill in manually if AI continues to fail`);
    }
}


downloadCSV() {
    const headers = ['#', 'Presentation', 'Recipient', 'Message', 'Organization', 'Date'];
    const rows = [headers];
    
    this.state.plaques.slice(0, this.state.quantity).forEach((plaque, i) => {
        rows.push([
            i + 1,
            plaque.presentation || '',
            plaque.recipient || '',
            plaque.message || '',
            plaque.organization || '',
            plaque.date || ''
        ]);
    });
    
    const csv = rows.map(row => 
        row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(',')
    ).join('\n');
    
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `plaque-order-${Date.now()}.csv`;
    a.click();
    URL.revokeObjectURL(url);
}


switchTab(tabName) {
    // Update active tab
    this.modal.querySelectorAll('.lw-plaque-tab').forEach(tab => {
        tab.classList.toggle('active', tab.dataset.tab === tabName);
    });
    
    // Render content
    const contentArea = this.modal.querySelector('.lw-plaque-tab-content');
    switch (tabName) {
        case 'layout':
        contentArea.innerHTML = this.renderLayoutTab();
        this.attachLayoutEvents();
        this.updateBasePlatePriceLabel();  // Update after rendering
    break;
        case 'headline':
            contentArea.innerHTML = this.renderHeadlineTab();
            this.attachHeadlineEvents();
            this.renderHeadlineContent();
            break;
        case 'text':
            contentArea.innerHTML = this.renderTextTab();
            this.attachTextEvents();
            break;
        case 'quantity':
            contentArea.innerHTML = this.renderQuantityTab();
            this.attachQuantityEvents();
            break;
    }
}


attachHeadlineEvents() {
    // Headline type selection - wait for DOM
    setTimeout(() => {
        const radioButtons = this.modal.querySelectorAll('input[name="headlineType"]');
        console.log('Found headline radios:', radioButtons.length); // Debug
        
        radioButtons.forEach(radio => {
            radio.addEventListener('change', (e) => {
                console.log('Headline type changed to:', e.target.value); // Debug
                this.state.headline.type = e.target.value;
                
                // Update active class on parent
                this.modal.querySelectorAll('.lw-radio-option').forEach(opt => {
                    opt.classList.remove('active');
                });
                e.target.closest('.lw-radio-option').classList.add('active');
                
                // Render the appropriate content
                this.renderHeadlineContent();


                // NEW: Auto-scroll to the content
                setTimeout(() => {
                    const contentArea = this.modal.querySelector('#headlineContent');
                    if (contentArea) {
                        contentArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 100); // 100ms delay to let it render


                this.updatePreview();
            });
            
        });
        
        // Trigger initial render if a type is already selected
        if (this.state.headline.type !== 'None') {
            this.renderHeadlineContent();
        }
    }, 50);
}    


renderHeadlineContent() {
    const container = this.modal.querySelector('#headlineContent');
    if (!container) return;
    
    switch (this.state.headline.type) {
        case 'Template':
            container.innerHTML = this.renderTemplateSelector();
            // Give DOM time to render
            setTimeout(() => {
                this.attachTemplateEvents();
            }, 10);
            break;
        case 'Custom':
            container.innerHTML = this.renderCustomHeadline();
            setTimeout(() => {
                this.attachCustomHeadlineEvents();
            }, 10);
            break;
        case 'Logo':
            container.innerHTML = this.renderLogoUpload();
            setTimeout(() => {
                this.attachLogoEvents();
            }, 10);
            break;
        default:
            container.innerHTML = '';
    }
}
    
    renderTemplateSelector() {
        const categories = Object.keys(this.config.headlineTemplates);
        const activeCategory = categories[0];
        
        return `
            <div class="lw-template-selector">
                <div class="lw-template-categories">
                    ${categories.map((cat, i) => `
                        <button class="lw-template-cat-btn ${i === 0 ? 'active' : ''}" data-category="${cat}">
                            ${cat}
                        </button>
                    `).join('')}
                </div>
                <div class="lw-template-grid">
                    ${this.config.headlineTemplates[activeCategory].map(template => `
                        <div class="lw-template-option ${this.state.headline.template?.url === template.url ? 'active' : ''}"
                             data-url="${template.url}" data-name="${this.escapeHtml(template.name)}">
                            <img src="${template.url}" alt="${this.escapeHtml(template.name)}">
                            <span>${this.escapeHtml(template.name)}</span>
                        </div>
                    `).join('')}
                </div>
            </div>
        `;
    }
    
    renderCustomHeadline() {
        return `
            <div class="lw-custom-headline">
                <label>Headline Text</label>
                <input type="text" class="lw-text-input" id="customHeadlineText" 
                       value="${this.escapeHtml(this.state.headline.customText)}" 
                       maxlength="50"
                       placeholder="e.g., Employee of the Month">
                
                <div class="lw-field-controls">
                    <select class="lw-font-select" id="customHeadlineFont">
                        ${this.config.fonts.map(font => 
                            `<option value="${font.value}" ${this.state.headline.customFont === font.value ? 'selected' : ''}>${this.escapeHtml(font.name)}</option>`
                        ).join('')}
                    </select>
                    <div class="lw-size-control">
                        <button class="lw-size-btn" id="headlineSizeDown">−</button>
                        <span id="headlineSize">${this.state.headline.customSize}px</span>
                        <button class="lw-size-btn" id="headlineSizeUp">+</button>
                    </div>
                </div>
            </div>
        `;
    }
    
    renderLogoUpload() {
    return `
        <div class="lw-logo-upload">
            <p class="lw-warning">⚠️ Logo setup fee: $15.00 (one-time)</p>
            <div class="lw-upload-area ${this.state.headline.uploadedLogo ? 'has-file' : ''}" id="logoUploadArea">
                ${this.state.headline.uploadedLogo ? 
                    `<img src="${this.state.headline.uploadedLogo}" alt="Logo" style="max-width: ${this.state.headline.logoSize || 70}%; max-height: ${this.state.headline.logoSize || 70}%;">` :
                    `<div class="lw-upload-prompt">
                        <span>📁</span>
                        <span>Click to upload logo</span>
                    </div>`
                }
            </div>
            <input type="file" id="logoFileInput" accept="image/*" style="display: none;">
            
            ${this.state.headline.uploadedLogo ? `
                <div class="lw-logo-controls">
                    <label>Logo Size</label>
                    <div class="lw-logo-size-slider">
                        <input type="range" id="logoSizeSlider" min="30" max="90" value="${this.state.headline.logoSize || 70}" step="5">
                        <span id="logoSizeValue">${this.state.headline.logoSize || 70}%</span>
                    </div>
                </div>
                
                <label class="lw-checkbox-option">
                    <input type="checkbox" id="logoSetupFee" ${this.state.headline.logoSetupFee ? 'checked' : ''}>
                    <span>Add logo setup fee (+$15.00)</span>
                </label>
                <p class="lw-help-text">Skip if you've already paid for this logo</p>
            ` : ''}
        </div>
    `;
}
    
    attachTemplateEvents() {
        // Category switching
        this.modal.querySelectorAll('.lw-template-cat-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const category = btn.dataset.category;
                
                // Update active button
                this.modal.querySelectorAll('.lw-template-cat-btn').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                
                // Update grid
                const grid = this.modal.querySelector('.lw-template-grid');
                grid.innerHTML = this.config.headlineTemplates[category].map(template => `
                    <div class="lw-template-option ${this.state.headline.template?.url === template.url ? 'active' : ''}"
                         data-url="${template.url}" data-name="${this.escapeHtml(template.name)}">
                        <img src="${template.url}" alt="${this.escapeHtml(template.name)}">
                        <span>${this.escapeHtml(template.name)}</span>
                    </div>
                `).join('');
                
                // Re-attach events
                this.attachTemplateSelectionEvents();
            });
        });
        
        this.attachTemplateSelectionEvents();
    }
    
    attachTemplateSelectionEvents() {
        this.modal.querySelectorAll('.lw-template-option').forEach(el => {
            el.addEventListener('click', () => {
                this.state.headline.template = {
                    url: el.dataset.url,
                    name: el.dataset.name
                };
                
                this.modal.querySelectorAll('.lw-template-option').forEach(e => e.classList.remove('active'));
                el.classList.add('active');
                
                this.updatePreview();
            });
        });
    }
    
    attachCustomHeadlineEvents() {
        const textInput = this.modal.querySelector('#customHeadlineText');
        const fontSelect = this.modal.querySelector('#customHeadlineFont');
        const sizeDown = this.modal.querySelector('#headlineSizeDown');
        const sizeUp = this.modal.querySelector('#headlineSizeUp');
        
        textInput.addEventListener('input', (e) => {
            this.state.headline.customText = e.target.value;
            this.updatePreview();
        });
        
        fontSelect.addEventListener('change', (e) => {
            this.state.headline.customFont = e.target.value;
            this.updatePreview();
        });
        
        ['click', 'touchstart'].forEach(evt => {
        sizeDown.addEventListener(evt, (e) => {
            e.preventDefault();
            this.state.headline.customSize = Math.max(16, this.state.headline.customSize - 2);
            this.modal.querySelector('#headlineSize').textContent = `${this.state.headline.customSize}px`;
            this.updatePreview();
        });
        });
        
        ['click', 'touchstart'].forEach(evt => {
        sizeUp.addEventListener(evt, (e) => {
            e.preventDefault();
            this.state.headline.customSize = Math.min(48, this.state.headline.customSize + 2);
            this.modal.querySelector('#headlineSize').textContent = `${this.state.headline.customSize}px`;
            this.updatePreview();
        });
        });
    }
    
    attachLogoEvents() {
    const uploadArea = this.modal.querySelector('#logoUploadArea');
    const fileInput = this.modal.querySelector('#logoFileInput');

    uploadArea.addEventListener('click', () => fileInput.click());

    fileInput.addEventListener('change', (e) => {
        const file = e.target.files[0];
        if (!file) return;
        
        // Validate file type — accept common web image formats only
        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml', 'image/webp'];
        if (!validTypes.includes(file.type)) {
            alert('Please upload a PNG, JPG, WEBP, or SVG image. Other file types are not supported.');
            e.target.value = '';
            return;
        }
        
        // Validate file size — 5MB max
        const MAX_SIZE = 5 * 1024 * 1024;
        if (file.size > MAX_SIZE) {
            const sizeMB = (file.size / 1024 / 1024).toFixed(1);
            alert(`Logo file is too large (${sizeMB}MB). Please upload an image under 5MB.`);
            e.target.value = '';
            return;
        }
        
        const reader = new FileReader();
        reader.onload = (event) => {
            this.state.headline.uploadedLogo = event.target.result;
            this.renderHeadlineContent();
            this.updatePreview();
        };
        reader.onerror = () => {
            alert('Failed to read the logo file. Please try again or use a different image.');
            e.target.value = '';
        };
        reader.readAsDataURL(file);
    });
    
    // Logo size slider
    const sizeSlider = this.modal.querySelector('#logoSizeSlider');
    if (sizeSlider) {
        sizeSlider.addEventListener('input', (e) => {
            this.state.headline.logoSize = parseInt(e.target.value);
            this.modal.querySelector('#logoSizeValue').textContent = `${e.target.value}%`;
            this.updatePreview();
        });
    }
    
    const feeCheckbox = this.modal.querySelector('#logoSetupFee');
    if (feeCheckbox) {
        feeCheckbox.addEventListener('change', (e) => {
            this.state.headline.logoSetupFee = e.target.checked;
            this.updatePrice();
        });
    }
}
    
async getAISuggestion() {
    const occasion = prompt('What is this plaque for?\n\nExamples:\n• "Employee of the Year award for Sarah Johnson"\n• "Retirement after 30 years for Michael Chen"\n• "Sales achievement for top performer"\n• "Community service recognition"');
    
    if (!occasion || occasion.trim() === '') return;
    
    // Show loading state
    const loadingNotice = document.createElement('div');
    loadingNotice.id = 'aiLoadingNotice';
    loadingNotice.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        padding: 20px 25px;
        border-radius: 10px;
        box-shadow: 0 5px 20px rgba(0,0,0,0.3);
        z-index: 10001;
        font-weight: 600;
    `;
    loadingNotice.innerHTML = `
        <div style="display: flex; align-items: center; gap: 15px;">
            <div style="
                border: 3px solid rgba(255,255,255,0.3);
                border-top: 3px solid white;
                border-radius: 50%;
                width: 24px;
                height: 24px;
                animation: spin 1s linear infinite;
            "></div>
            <div>Generating plaque text...</div>
        </div>
    `;
    document.body.appendChild(loadingNotice);
    
    // Add spinner animation if not exists
    if (!document.getElementById('spinnerStyle')) {
        const style = document.createElement('style');
        style.id = 'spinnerStyle';
        style.textContent = `@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`;
        document.head.appendChild(style);
    }
    
    try {
        const response = await fetch('https://plaque-ai-helper.noisy-waterfall-ce1b.workers.dev/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                prompt: `Generate award plaque text for: "${occasion}".


CRITICAL FIELD DEFINITIONS:
- "presentation" = Opening phrase ONLY (examples: "Presented To:", "Awarded To:", "In Recognition Of:", "In Honor Of:")
- "recipient" = Person's NAME ONLY (examples: "John Smith", "Sarah Johnson", "Michael Chen")
- "message" = The FULL achievement/recognition message (examples: "For Outstanding Leadership and Dedication", "In Recognition of 30 Years of Service")
- "organization" = Company/organization name ONLY (examples: "ABC Corporation", "City Fire Department") 
- "date" = Year ONLY or leave as "${new Date().getFullYear()}" (examples: "2025", "2024")


EXAMPLE 1 - Employee Award:
{"presentation":"Presented To:","recipient":"Sarah Johnson","message":"Employee of the Year for Outstanding Performance","organization":"Tech Solutions Inc","date":"2025"}


EXAMPLE 2 - Retirement:
{"presentation":"In Recognition Of:","recipient":"Michael Chen","message":"30 Years of Dedicated Service and Leadership","organization":"City Hospital","date":"2025"}


EXAMPLE 3 - Achievement:
{"presentation":"Awarded To:","recipient":"Jennifer Martinez","message":"Top Sales Performer of 2025","organization":"Global Sales Corp","date":"2025"}


Now generate for: "${occasion}"


Return ONLY valid JSON (no markdown, no code blocks, no explanations):
{"presentation":"","recipient":"","message":"","organization":"","date":""}`,
                productName: 'Award Plaque',
                productType: 'Recognition'
            })
        });
        
        if (!response.ok) {
            throw new Error(`Server error ${response.status}`);
        }
        
        const data = await response.json();
        console.log('=== AI RAW RESPONSE ===');
        console.log(data);
        
        let responseText = data.text || data.content || data.response || JSON.stringify(data);
        console.log('=== RESPONSE TEXT ===');
        console.log(responseText);
        
        // Try to parse JSON with multiple fallbacks
        let plaqueData;
        try {
            // Remove markdown formatting
            responseText = responseText.replace(/```json\s*/g, '').replace(/```\s*/g, '').trim();
            
            // Method 1: Try direct parse
            try {
                plaqueData = JSON.parse(responseText);
            } catch (e1) {
                // Method 2: Try finding JSON object
                const jsonMatch = responseText.match(/\{[^{}]*"presentation"[^{}]*\}/);
                if (jsonMatch) {
                    plaqueData = JSON.parse(jsonMatch[0]);
                } else {
                    throw new Error('No JSON object found');
                }
            }
        } catch (parseError) {
            console.warn('JSON parsing failed:', parseError);
            console.log('Attempting text fallback...');
            
            // FALLBACK: Try to extract values intelligently
            const presentationMatch = responseText.match(/(?:presentation|opening)["\s:]+([^""\n,}]+)/i);
            const recipientMatch = responseText.match(/(?:recipient|name)["\s:]+([^""\n,}]+)/i);
            const messageMatch = responseText.match(/(?:message|achievement)["\s:]+([^""\n,}]+)/i);
            const organizationMatch = responseText.match(/(?:organization|company)["\s:]+([^""\n,}]+)/i);
            const dateMatch = responseText.match(/(?:date|year)["\s:]+([^""\n,}]+)/i);
            
            plaqueData = {
                presentation: presentationMatch ? presentationMatch[1].trim() : 'Presented To:',
                recipient: recipientMatch ? recipientMatch[1].trim() : 'Recipient Name',
                message: messageMatch ? messageMatch[1].trim() : 'In Recognition of Outstanding Service',
                organization: organizationMatch ? organizationMatch[1].trim() : 'Organization Name',
                date: dateMatch ? dateMatch[1].trim() : new Date().getFullYear().toString()
            };
        }
        
        console.log('=== PARSED PLAQUE DATA ===');
        console.log(plaqueData);
        
        // Remove loading notice
        loadingNotice.remove();
        
        // Update state
        if (plaqueData.presentation) this.state.textFields.presentation.content = plaqueData.presentation;
        if (plaqueData.recipient) this.state.textFields.recipient.content = plaqueData.recipient;
        if (plaqueData.message) this.state.textFields.message.content = plaqueData.message;
        if (plaqueData.organization) this.state.textFields.organization.content = plaqueData.organization;
        if (plaqueData.date) this.state.textFields.date.content = plaqueData.date;
        
        // Switch to text tab
        this.switchTab('text');
        
        // Update DOM inputs directly
        setTimeout(() => {
            const inputs = {
                presentation: this.modal.querySelector('.lw-text-input[data-field="presentation"]'),
                recipient: this.modal.querySelector('.lw-text-input[data-field="recipient"]'),
                message: this.modal.querySelector('.lw-text-input[data-field="message"]'),
                organization: this.modal.querySelector('.lw-text-input[data-field="organization"]'),
                date: this.modal.querySelector('.lw-text-input[data-field="date"]')
            };
            
            Object.keys(inputs).forEach(field => {
                if (inputs[field] && plaqueData[field]) {
                    inputs[field].value = plaqueData[field];
                    inputs[field].dispatchEvent(new Event('input', { bubbles: true }));
                }
            });
            
            this.updatePreview();
        }, 100);
        
        // Show success notification
        const successNotice = document.createElement('div');
        successNotice.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: #28a745;
            color: white;
            padding: 20px 25px;
            border-radius: 10px;
            box-shadow: 0 5px 20px rgba(0,0,0,0.3);
            z-index: 10001;
            font-weight: 600;
        `;
        successNotice.innerHTML = `
            <div style="display: flex; align-items: center; gap: 10px;">
                <span style="font-size: 24px;">✓</span>
                <div>
                    <div style="font-weight: 700;">AI Suggestion Applied!</div>
                    <div style="font-size: 14px; margin-top: 5px; opacity: 0.9;">Text fields updated. Edit as needed.</div>
                </div>
            </div>
        `;
        document.body.appendChild(successNotice);
        
        setTimeout(() => {
            successNotice.style.opacity = '0';
            successNotice.style.transition = 'opacity 0.3s ease';
            setTimeout(() => successNotice.remove(), 300);
        }, 5000);
        
    } catch (error) {
        console.error('AI Error:', error);
        
        const notice = document.getElementById('aiLoadingNotice');
        if (notice) notice.remove();
        
        alert(`AI suggestion failed: ${error.message}\n\nPlease try:\n• "Employee of the Year award for John Smith"\n• "Retirement for Sarah after 25 years"\n• Entering text manually`);
    }
}
    
    updatePreview() {
        const container = this.modal.querySelector('.lw-plaque-preview-container');
        const basePlate = this.modal.querySelector('.lw-plaque-baseplate');
        const plate = this.modal.querySelector('.lw-plaque-plate');
        const headlineLayer = this.modal.querySelector('.lw-headline-layer');
        const textLayer = this.modal.querySelector('.lw-text-layer');
        
        // Update orientation
        container.dataset.orientation = this.state.style.orientation.toLowerCase();
        
        // Update plate color
        const bgColor = this.state.style.engravingColor.bgColor;
        plate.style.backgroundImage = `url('${this.config.backgroundPlates[bgColor]}')`;
        
        // Update base plate
        if (this.state.style.useBasePlate) {
            const plateColor = this.state.style.engravingColor.engravingColor === '#C4C4C4' ? 'Silver' : 'Gold';
            basePlate.style.backgroundImage = `url('${this.config.basePlates[plateColor].url}')`;
            basePlate.style.display = 'block';
        } else {
            basePlate.style.display = 'none';
        }
        
        // Update corner screws
        this.updateCornerScrews();
        
        // Update headline
        this.updateHeadlineLayer(headlineLayer);
        
        // Update text
        this.updateTextLayer(textLayer);
    }
    
    updateCornerScrews() {
        const plate = this.modal.querySelector('.lw-plaque-plate');
        let screwLayer = plate.querySelector('.lw-corner-screws');
        
        if (this.state.style.useCornerScrews) {
            if (!screwLayer) {
                screwLayer = document.createElement('div');
                screwLayer.className = 'lw-corner-screws';
                plate.appendChild(screwLayer);
            }
            
            screwLayer.innerHTML = '';
            ['top-left', 'top-right', 'bottom-left', 'bottom-right'].forEach(pos => {
                const screw = document.createElement('div');
                screw.className = `lw-screw lw-screw-${pos}`;
                screw.style.backgroundColor = this.state.style.engravingColor.engravingColor;
                screwLayer.appendChild(screw);
            });
        } else if (screwLayer) {
            screwLayer.remove();
        }
    }
    
    updateHeadlineLayer(layer) {
    layer.innerHTML = '';
    
    const hasHeadline = (this.state.headline.type === 'Template' && this.state.headline.template) ||
                       (this.state.headline.type === 'Custom' && this.state.headline.customText) ||
                       (this.state.headline.type === 'Logo' && this.state.headline.uploadedLogo);
    
    layer.parentElement.classList.toggle('has-headline', hasHeadline);
    
    if (this.state.headline.type === 'Template' && this.state.headline.template) {
        const img = document.createElement('img');
        img.src = this.state.headline.template.url;
        img.style.filter = this.getSVGFilter(this.state.style.engravingColor.engravingColor);
        layer.appendChild(img);
    } else if (this.state.headline.type === 'Custom' && this.state.headline.customText) {
        const div = document.createElement('div');
        div.className = 'lw-custom-headline';
        div.style.fontFamily = this.state.headline.customFont;
        div.style.fontSize = `${this.state.headline.customSize}px`;
        div.style.color = this.state.style.engravingColor.engravingColor;
        div.textContent = this.state.headline.customText;
        layer.appendChild(div);
    } else if (this.state.headline.type === 'Logo' && this.state.headline.uploadedLogo) {
        const img = document.createElement('img');
        img.src = this.state.headline.uploadedLogo;
        img.className = 'lw-uploaded-logo';
        img.style.maxWidth = `${this.state.headline.logoSize}%`;
        img.style.maxHeight = `${this.state.headline.logoSize}%`;
        layer.appendChild(img);
    }
}
    
    updateTextLayer(layer) {
        layer.innerHTML = '';
        
        Object.entries(this.state.textFields).forEach(([key, field]) => {
            const div = document.createElement('div');
            div.className = `lw-text-line lw-text-${key}`;
            div.style.fontFamily = field.font;
            div.style.fontSize = `${field.size}px`;
            div.style.color = this.state.style.engravingColor.engravingColor;
            div.textContent = field.content;
            layer.appendChild(div);
        });
    }
    
    getSVGFilter(color) {
    if (color === '#C4C4C4') { // Silver - matches #C4C4C4 more accurately
        return 'brightness(0) saturate(100%) invert(79%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(98%) contrast(88%)';
    } else if (color === '#B8A35F') { // Gold
        return 'brightness(0) saturate(100%) invert(72%) sepia(15%) saturate(1149%) hue-rotate(2deg) brightness(91%) contrast(87%)';
    }
    return '';
}
    
    calculateBasePlateCost() {
        const sqInches = this.state.product.width * this.state.product.height;
        const plateColor = this.state.style.engravingColor.engravingColor === '#C4C4C4' ? 'Silver' : 'Gold';
        const rawCost = this.config.basePlates[plateColor].cost * sqInches;
        return Math.ceil(rawCost) - 0.01;
    }
    
    calculatePerPlaquePrice() {
        const sqInches = this.state.product.width * this.state.product.height;
        let price = this.state.product.basePrice || 0;
        
        // Check qty-break radio buttons for tiered pricing
        const radios = document.querySelectorAll('input[name="product-qty-breaks"]');
        let bestTier = null;
        radios.forEach(r => {
            const qty = parseInt(r.dataset.qty);
            if (qty <= this.state.quantity && (!bestTier || qty > bestTier.qty)) {
                bestTier = { qty: qty, el: r };
            }
        });
        
        if (bestTier) {
            // Auto-check WITHOUT triggering change events
            if (!bestTier.el.checked) {
                this._updatingQuantity = true;
                bestTier.el.checked = true;
                this._updatingQuantity = false;
            }
            const raw = bestTier.el.dataset.totalPrice;
            if (raw) price = parseFloat(raw.replace(/[^0-9.]/g, '')) / bestTier.qty;
        } else {
            this._updatingQuantity = true;
            radios.forEach(r => r.checked = false);
            this._updatingQuantity = false;
        }
        
        // Color surcharge - handle both flat fees (wood fill) and per-sq-inch costs
        const colorCost = this.state.style.engravingColor.cost;
        if (colorCost > 0) {
            if (this.state.style.engravingColor.isFillOption) {
                // Wood fill options are flat fees
                price += colorCost;
            } else {
                // Standard colors are per sq inch
                const rawCost = colorCost * sqInches;
                const roundedColorCost = Math.ceil(rawCost) - 0.01;
                price += roundedColorCost;
            }
        }
        
        // Base plate (only for standard plaques)
        if (this.state.style.useBasePlate && this.config.plaqueTypes[this.state.plaqueType]?.hasPlate) {
            price += this.calculateBasePlateCost();
        }


        // Corner screws - $1.99 flat fee (only for standard plaques)
    if (this.state.style.useCornerScrews && this.config.plaqueTypes[this.state.plaqueType]?.hasPlate) {
        price += 1.99;
    }
        return price;
    }
    
    calculateTotalPrice() {
        let total = this.calculatePerPlaquePrice() * this.state.quantity;
        
        // Logo setup fee (one-time)
        if (this.state.headline.logoSetupFee) {
            total += this.config.fees.logoSetup;
        }
        
        return total;
    }
    
updatePrice() {
        const priceEl = this.modal.querySelector('.lw-plaque-price-value');
        const perPlaqueEl = this.modal.querySelector('.lw-plaque-price-per-plaque');
        
        if (priceEl) {
            priceEl.textContent = `$${this.calculateTotalPrice().toFixed(2)}`;
        }
        if (perPlaqueEl) {
            perPlaqueEl.textContent = `$${this.calculatePerPlaquePrice().toFixed(2)}`;
        }
    
    // Also update base plate label since price might have changed
    this.updateBasePlatePriceLabel();
}


updateBasePlatePriceLabel() {
    const label = this.modal.querySelector('#basePlatePriceLabel');
    if (label) {
        const cost = this.calculateBasePlateCost();
        label.textContent = `Add Base Plate (+$${cost.toFixed(2)})`;
    }
}
    
async generatePreviewImage() {
        if (typeof html2canvas === 'undefined') {
            console.error('html2canvas not loaded');
            return null;
        }


        let originalTextFields = null;
        if (this.state.quantity > 1 && this.state.plaques.length > 0) {
            originalTextFields = JSON.parse(JSON.stringify(this.state.textFields));
            const firstPlaque = this.state.plaques[0];
            this.state.textFields.presentation.content = firstPlaque.presentation;
            this.state.textFields.recipient.content = firstPlaque.recipient;
            this.state.textFields.message.content = firstPlaque.message;
            this.state.textFields.organization.content = firstPlaque.organization;
            this.state.textFields.date.content = firstPlaque.date;
            this.updatePreview();
            await new Promise(resolve => setTimeout(resolve, 100));
        }


        const previewContainer = this.modal.querySelector('.lw-plaque-preview-container');
        if (!previewContainer) return null;


        // Store original headline images
        const headlineImages = previewContainer.querySelectorAll('.lw-headline-layer img');
        const originalSources = new Map();
        
       // --- Store original container styles ---
    const originalStyles = {
        width: previewContainer.style.width,
        height: previewContainer.style.height,
        aspectRatio: previewContainer.style.aspectRatio
    };
    
    // --- Fix portrait wood image for html2canvas ---
    const woodImg = previewContainer.querySelector('.lw-plaque-wood');
    const originalWoodStyles = {
        width: woodImg.style.width,
        height: woodImg.style.height,
        top: woodImg.style.top,
        transform: woodImg.style.transform
    };
    
    if (this.state.style.orientation === 'Portrait') {
        // Force explicit dimensions on the wood image for html2canvas
        // This ensures it maintains the 7:9 aspect ratio during capture
        woodImg.style.width = '100%';
       woodImg.style.height = 'auto';
        // Center the auto-height image vertically
        woodImg.style.top = '50%';
        woodImg.style.transform = 'translateY(-50%)';
    }


        try {
            // --- 1. Pre-color headline images ---
            const engravingColor = this.state.style.engravingColor.engravingColor;
            for (const img of headlineImages) {
                originalSources.set(img, img.src);
                try {
                    const coloredSrc = await convertImageToColoredVersion(img, engravingColor);
                    img.src = coloredSrc;
                    await new Promise((resolve, reject) => {
                        img.onload = resolve;
                        img.onerror = reject;
                    });
                } catch (error) {
                    console.error('Failed to pre-color headline:', error);
                }
            }


            
            // Give browser a moment for any changes to apply
            await new Promise(resolve => setTimeout(resolve, 50));
        
            // --- 4. Capture the container ---
    const canvas = await html2canvas(previewContainer, {
        backgroundColor: '#FFFFFF',
        scale: 1,
        logging: false,
        allowTaint: true,
        useCORS: true,
        // Updated rule to fix console errors from search.js
        ignoreElements: (element) => {
            if (!element.id && !element.className) return false; // Safety check


            const id = (typeof element.id === 'string') ? element.id : '';
            const classes = (typeof element.className === 'string') ? element.className : '';


            return (
                element.tagName === 'PREDICTIVE-SEARCH' ||
                id.includes('search') ||
                classes.includes('search') ||
                (element.tagName === 'FORM' && element.action.includes('/search'))
            );
        }
    });
            
            // Constrain output size for Shopify line item property limits.
            // Max 400px on longest edge keeps the data URL ~15-25KB.
            // The preview is for admin reference, not customer viewing.
            const MAX_PREVIEW_DIM = 400;
            const longestEdge = Math.max(canvas.width, canvas.height);
            
            if (longestEdge > MAX_PREVIEW_DIM) {
                const scale = MAX_PREVIEW_DIM / longestEdge;
                const resized = document.createElement('canvas');
                resized.width = Math.round(canvas.width * scale);
                resized.height = Math.round(canvas.height * scale);
                const rctx = resized.getContext('2d');
                rctx.imageSmoothingEnabled = true;
                rctx.imageSmoothingQuality = 'high';
                rctx.fillStyle = '#FFFFFF';
                rctx.fillRect(0, 0, resized.width, resized.height);
                rctx.drawImage(canvas, 0, 0, resized.width, resized.height);
                return resized.toDataURL('image/jpeg', 0.7);
            }
            
            return canvas.toDataURL('image/jpeg', 0.7);


        } catch (error) {
            console.error('Plaque preview generation failed:', error);
            return null;
      } finally {
        // --- 5. ALWAYS restore original state ---
        // Restore any styles we may have changed
        previewContainer.style.height = originalStyles.height;
        previewContainer.style.aspectRatio = originalStyles.aspectRatio;
        
        // Restore wood image dimensions
        const woodImg = previewContainer.querySelector('.lw-plaque-wood');
        if (woodImg && this.state.style.orientation === 'Portrait') {
            woodImg.style.width = originalWoodStyles.width || '';
            woodImg.style.height = originalWoodStyles.height || '';
            woodImg.style.top = originalWoodStyles.top || '';
            woodImg.style.transform = originalWoodStyles.transform || '';
        }
            if (originalTextFields) {
                this.state.textFields = originalTextFields;
                this.updatePreview(); // Re-render the user's original view
            }
            // Restore original headline images
            for (const [img, originalSrc] of originalSources.entries()) {
                img.src = originalSrc;
            }
        }
    }




    async addToCart() {
    // Guard against double-clicks while a cart-add is in progress
    if (this._addingToCart) {
        console.warn('Add to cart already in progress, ignoring duplicate click');
        return;
    }

    // Capture the modal and button references NOW, before any async work.
    // If the customizer modal gets closed during the await (e.g., user clicked
    // outside the disclaimer, which can bubble to the customizer's overlay handler),
    // we still have valid references to work with.
    const modalRef = this.modal;
    const btn = modalRef ? modalRef.querySelector('#addToCartBtn') : null;
    
    if (!btn) {
        console.error('Add to cart button not found — modal may have been closed');
        return;
    }

    // Show the shared disclaimer modal. Wait for user to accept or cancel.
    if (window.LyteWorkShared && typeof window.LyteWorkShared.showDisclaimer === 'function') {
        const accepted = await window.LyteWorkShared.showDisclaimer();
        if (!accepted) return;
    } else {
        // Fail-safe fallback if shared snippet didn't load
        console.warn('LyteWorkShared not loaded; falling back to native confirm');
        if (!confirm('I confirm my engraving details are correct and accept the customization terms.')) return;
    }

    this._addingToCart = true;
    
    btn.disabled = true;
    btn.textContent = 'Adding...';
    
    // Show shared loading overlay
    if (window.LyteWorkShared) {
        window.LyteWorkShared.showLoading();
    }
    
    try {
        // Ensure html2canvas is loaded
        try {
            await ensureHtml2CanvasLoaded();
        } catch (error) {
            console.error('Failed to load preview library:', error);
            alert('Failed to load preview library. Please try again.');
            btn.disabled = false;
            btn.textContent = 'Add to Cart';
            if (window.LyteWorkShared) window.LyteWorkShared.hideLoading();
            this._addingToCart = false;
            return;
        }


        // Generate preview
        btn.textContent = 'Generating Preview...';
        const previewImage = await this.generatePreviewImage();
        
        btn.textContent = 'Adding...'; // Back to original message
        // --- Start of new price logic ---
       
        // Calculate surcharges using the existing helper functions for consistency
        // --- Start of new price logic ---
        // Calculate surcharges using the existing helper functions for consistency
        const surchargeBreakdown = [];


        // 1. Calculate the per-item surcharges (all addons EXCEPT one-time logo fee)
        // This function is now fixed and returns the correct per-plaque price
        const perPlaquePrice = this.calculatePerPlaquePrice();
        const basePrice = this.state.product.basePrice;
        const perItemSurchargeDollars = perPlaquePrice - basePrice;


        // 2. Calculate the one-time logo fee
        const oneTimeLogoFeeDollars = this.state.headline.logoSetupFee ? this.config.fees.logoSetup : 0;


        // 3. Calculate the final *total* surcharge for the whole order
        const totalSurchargeDollars = (perItemSurchargeDollars * this.state.quantity) + oneTimeLogoFeeDollars;


        // 4. Calculate the per-item surcharge to send to Shopify
            // (This amortizes the one-time fee across all items)
            let finalSurchargePerItemDollars = 0;
            if (this.state.quantity > 0) {
                finalSurchargePerItemDollars = totalSurchargeDollars / this.state.quantity;
            }


            // 5. Convert to cents for Shopify
            let totalSurchargeInCents = Math.round(finalSurchargePerItemDollars * 100);


            // --- Build Surcharge Breakdown for properties ---
            // (This is the single, correct block)
            const sqInches = this.state.product.width * this.state.product.height;
            if (this.state.style.engravingColor.cost > 0) {
                const goldCost = this.state.style.engravingColor.cost * sqInches;
                const roundedGoldCost = Math.ceil(goldCost) - 0.01;
                surchargeBreakdown.push(`Gold Engraving: $${roundedGoldCost.toFixed(2)}/ea`);
            }
            
            if (this.state.style.useBasePlate) {
                const plateCost = this.calculateBasePlateCost();
                surchargeBreakdown.push(`Base Plate: $${plateCost.toFixed(2)}/ea`);
            }


            if (this.state.style.useCornerScrews) {
                surchargeBreakdown.push(`Corner Tacks: $1.99/ea`);
            }
            
            if (this.state.headline.logoSetupFee) {
                surchargeBreakdown.push(`Logo Setup: $15.00 (one-time)`);
            }
            // --- End of new price logic ---
            
            // Build properties
            const properties = {
                'Orientation': this.state.style.orientation,
                'Engraving Color': this.state.style.engravingColor.name,
                'Base Plate': this.state.style.useBasePlate ? 'Yes' : 'No',
                'Corner Tacks': this.state.style.useCornerScrews ? 'Yes' : 'No',
                '_plaque_id': Date.now().toString()
            };


            // Add Headline info
            let headlineInfo = 'None';
            if (this.state.headline.type === 'Template' && this.state.headline.template) {
                headlineInfo = `Template: ${this.state.headline.template.name}`;
            } else if (this.state.headline.type === 'Custom' && this.state.headline.customText) {
                headlineInfo = `Custom: ${this.state.headline.customText}`;
            } else if (this.state.headline.type === 'Logo') {
                headlineInfo = 'Uploaded Logo';
            }
            properties['Headline'] = headlineInfo;
            
            // Surcharge is now handled as a separate line item below.
            // Previously these properties were used by cart-addon-pricing.js
            // to visually inflate the cart price. That display rewrite has been
            // removed in favor of an honest two-line-item approach.
        
        // Add preview image property
        if (previewImage) {
            properties['_preview'] = previewImage;
        }
        
        // Handle multiple plaques
        if (this.state.quantity > 1) {
            properties['_AllPlaquesData'] = this.generatePlaquesCSV();


            // Add individual plaque details for cart visibility
            this.state.plaques.slice(0, this.state.quantity).forEach((plaque, index) => {
                const plaqueNum = index + 1;
                // This creates a visual separator in the cart properties list
                properties[`--- Plaque ${plaqueNum}`] = `---`; 
                properties[`Plaque ${plaqueNum} - Presentation`] = plaque.presentation || 'n/a';
                properties[`Plaque ${plaqueNum} - Recipient`] = plaque.recipient || 'n/a';
                properties[`Plaque ${plaqueNum} - Message`] = plaque.message || 'n/a';
                properties[`Plaque ${plaqueNum} - Organization`] = plaque.organization || 'n/a';
                properties[`Plaque ${plaqueNum} - Date`] = plaque.date || 'n/a';
            });
        } else {
            properties['Presentation'] = this.state.textFields.presentation.content;
            properties['Recipient'] = this.state.textFields.recipient.content;
            properties['Message'] = this.state.textFields.message.content;
            properties['Organization'] = this.state.textFields.organization.content;
            properties['Date'] = this.state.textFields.date.content;
        }
        
        // Build form data for main product
        const finalVariantId = this.state.product.variantId;
        if (!finalVariantId) {
            throw new Error('Could not determine product variant ID. Add to cart failed.');
        }
        
        // Generate a unique link ID to associate this product with its surcharge.
        const lwLinkId = 'lw_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
        properties['_lw_link_id'] = lwLinkId;
        
        const formData = new FormData();
        formData.append('id', finalVariantId);
        formData.append('quantity', this.state.quantity);
        
        Object.entries(properties).forEach(([key, value]) => {
            formData.append(`properties[${key}]`, value);
        });
        
        // Add main product to cart
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.description || 'Failed to add main product to cart');
        }

        // --- Add surcharge as a separate, customer-facing line item ---
        // Uses the hidden "Customization Options" variant priced at $0.01.
        // Note: totalSurchargeInCents was already amortized per-item earlier in this function.
        // For multi-quantity orders, we multiply back up to get the TOTAL surcharge for the order.
        // Use total surcharge directly to avoid amortization rounding errors
        const totalOrderSurchargeCents = Math.round(totalSurchargeDollars * 100);
        
        if (totalOrderSurchargeCents > 0) {
            const SURCHARGE_VARIANT_ID = '41832906817610'; // "Customization Options"

            const surchargeFormData = new FormData();
            surchargeFormData.append('id', SURCHARGE_VARIANT_ID);
            surchargeFormData.append('quantity', totalOrderSurchargeCents);

            // Visible to customer — explains what they're paying for and on which product
            const productTitle = this.state.product.title || 'Plaque';
            const forLabel = this.state.quantity > 1 
                ? `${productTitle} (${this.state.quantity})` 
                : productTitle;
            surchargeFormData.append('properties[For]', forLabel);
            surchargeFormData.append('properties[_lw_link_id]', lwLinkId);

            // Each surcharge item rendered as its own property line for readability
            surchargeBreakdown.forEach((item) => {
                const colonIndex = item.indexOf(':');
                if (colonIndex > -1) {
                    const label = item.substring(0, colonIndex).trim();
                    const value = item.substring(colonIndex + 1).trim();
                    surchargeFormData.append(`properties[${label}]`, value);
                }
            });

            const surchargeResponse = await fetch('/cart/add.js', {
                method: 'POST',
                body: surchargeFormData
            });

            if (!surchargeResponse.ok) {
                const surchargeError = await surchargeResponse.json();
                console.error('Surcharge add failed:', surchargeError);

                // Roll back the main product so cart isn't in an inconsistent state
                try {
                    await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            id: finalVariantId,
                            quantity: 0
                        })
                    });
                    console.log('Rolled back main product after surcharge failure');
                } catch (rollbackError) {
                    console.error('Rollback also failed:', rollbackError);
                }

                alert(
                    'Sorry, there was a problem adding your customization. ' +
                    'Your cart has not been changed. Please try again, or contact us if the problem persists.'
                );

                btn.disabled = false;
                btn.textContent = 'Add to Cart';
                if (window.LyteWorkShared) window.LyteWorkShared.hideLoading();
                return;
            }
        }

        this.close();
        sessionStorage.setItem('openCartDrawer', 'true');
        window.location.href = '/cart';
        
    } catch (error) {
        console.error('Cart error:', error);
        alert('Failed to add to cart. Please try again.');
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
        if (window.LyteWorkShared) window.LyteWorkShared.hideLoading();
    } finally {
        // Always release the guard, even if something threw above
        this._addingToCart = false;
    }
}


generatePlaquesCSV() {
    const headers = ['#', 'Presentation', 'Recipient', 'Message', 'Organization', 'Date'];
    const rows = [headers];
    
    this.state.plaques.slice(0, this.state.quantity).forEach((plaque, i) => {
        rows.push([
            i + 1,
            plaque.presentation || '',
            plaque.recipient || '',
            plaque.message || '',
            plaque.organization || '',
            plaque.date || ''
        ]);
    });
    
    return rows.map(row => 
        row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(',')
    ).join('\n');
}


}  // ← CLOSES THE CLASS
// ============================================
// HTML2CANVAS LOADER WITH PROMISE
// ============================================
let html2canvasLoaded = false;
let html2canvasPromise = null;


function ensureHtml2CanvasLoaded() {
    if (html2canvasLoaded) {
        return Promise.resolve();
    }
    
    if (html2canvasPromise) {
        return html2canvasPromise;
    }
    
    html2canvasPromise = new Promise((resolve, reject) => {
        if (typeof html2canvas !== 'undefined') {
            console.log('✅ html2canvas already loaded');
            html2canvasLoaded = true;
            resolve();
            return;
        }
        
        console.log('⏳ Loading html2canvas...');
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
        
        script.onload = () => {
            console.log('✅ html2canvas loaded successfully!');
            html2canvasLoaded = true;
            resolve();
        };
        
        script.onerror = () => {
            console.error('❌ html2canvas failed to load!');
            reject(new Error('Failed to load html2canvas'));
        };
        
        document.head.appendChild(script);
    });
    
    return html2canvasPromise;
}
async function convertImageToColoredVersion(imgElement, hexColor) {
    return new Promise((resolve, reject) => {
        try {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            
            const sourceImg = new Image();
            sourceImg.crossOrigin = 'anonymous';
            
            sourceImg.onload = function() {
                canvas.width = sourceImg.naturalWidth;
                canvas.height = sourceImg.naturalHeight;
                
                ctx.drawImage(sourceImg, 0, 0);
                
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const data = imageData.data;
                
                const r = parseInt(hexColor.slice(1, 3), 16);
                const g = parseInt(hexColor.slice(3, 5), 16);
                const b = parseInt(hexColor.slice(5, 7), 16);


                for (let i = 0; i < data.length; i += 4) {
                    const alpha = data[i + 3];
                    if (alpha > 0) {
                        // This logic assumes the source is black/grayscale
                        // It uses the source pixel's darkness as the *alpha* for the new color
                        const intensity = data[i] / 255; // How black is it (0=black, 1=white)
                        
                        // We are tinting, so black (0) becomes the full color
                        // and white (1) remains white.
                        if (intensity < 0.95) { // Don't color pure white pixels
                            data[i] = r;     // R
                            data[i + 1] = g; // G
                            data[i + 2] = b; // B
                            // Use the original image's alpha, but fade based on intensity
                            data[i + 3] = alpha * (1 - intensity);
                        }
                    }
                }
                
                ctx.putImageData(imageData, 0, 0);
                const coloredDataUrl = canvas.toDataURL('image/png');
                resolve(coloredDataUrl);
            };
            
            sourceImg.onerror = () => {
                console.error('Failed to load image for color conversion');
                reject(new Error('Image load failed'));
            };
            
            // Handle cross-origin issues with Shopify CDN
            let src = imgElement.src;
            if (src.startsWith('https://cdn.shopify.com/') && !src.includes('crossorigin=anonymous')) {
                 src = src.includes('?') ? `${src}&crossorigin=anonymous` : `${src}?crossorigin=anonymous`;
            }
            sourceImg.src = src;


        } catch (error) {
            console.error('Color conversion error:', error);
            reject(error);
        }
    });
}
// Initialize
console.log('🔧 PlaqueCustomizer: Script loaded, checking DOM state...');
if (document.readyState === 'loading') {
    console.log('🔧 PlaqueCustomizer: DOM still loading, waiting for DOMContentLoaded...');
    document.addEventListener('DOMContentLoaded', () => {
        console.log('🔧 PlaqueCustomizer: DOMContentLoaded fired, creating instance...');
        new PlaqueCustomizer();
    });
} else {
    console.log('🔧 PlaqueCustomizer: DOM ready, creating instance immediately...');
    new PlaqueCustomizer();
}